(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
// Entry point for parceljs bundling.
// This file should only contain imports.
// In particular, code between imports will not work.
// (https://github.com/parcel-bundler/parcel/issues/3644#issuecomment-542117712)
$(function() {
    var autoSubmit = function autoSubmit(element) {
        var form = $(element).parents("form");
        form.get(0).submit();
    };
    $("input[data-auto-submit]").on("change", function() {
        autoSubmit(this);
    });
    $("label[data-auto-submit]").on("click", function() {
        autoSubmit(this);
    });
    $("select[data-auto-submit]").on("change", function() {
        autoSubmit(this);
    });
});
window.clearHash = function() {
    var uri = window.location.toString();
    if (uri.indexOf("#") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("#"));
        window.history.replaceState({}, document.title, clean_uri);
    }
};


/**
 * Calendly popup handler, triggered when someone clicks the 'request call' link.
 *
 * Only works if Calendly is defined by some prior script.
 * This is loaded directly into the browser so use vanilla Javascript.
 *
 * Accepts a JSON string which unpacks to a CalendlyData instance.
 */ $(function() {
    if (window.showCalendlyWidget === undefined) window.showCalendlyWidget = function(optionString) {
        try {
            var haveCalendly = typeof Calendly !== "undefined";
            var data = JSON.parse(optionString) || {};
            if (haveCalendly && data.integrationUrl) {
                // this thing will have one or both of integration type and config id, plus page source
                var resolvedIntegration = [
                    data.integrationType || "",
                    data.configurationUID || "",
                    data.pageId || ""
                ].join("|");
                var parameters = {
                    url: data.integrationUrl,
                    prefill: {
                        name: data.subscriberName,
                        email: data.subscriberEmail,
                        customAnswers: data.customAnswers || {}
                    },
                    // pass through the integration and the member so that the webhook
                    // can trigger the correct partner integration
                    // this data will also be logged in Calendly so 55R can see who booked what
                    utm: {
                        utmSource: data.integrationSource,
                        utmCampaign: resolvedIntegration,
                        utmContent: data.subscriberId,
                        utmMedium: data.registrationType
                    }
                };
                Calendly.initPopupWidget(parameters);
            } else console.warn("Not enough info to trigger calendly", optionString);
        } catch (err) {
            console.warn("Failed to show calendly widget", err);
        }
        // required
        return false;
    };
});


var $c8f70d1a332681e9$exports = {};
/*!
 * clipboard.js v2.0.8
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $c8f70d1a332681e9$exports = factory();
})($c8f70d1a332681e9$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 134: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */ var ClipboardAction = /*#__PURE__*/ function() {
                    /**
   * @param {Object} options
   */ function ClipboardAction(options) {
                        _classCallCheck(this, ClipboardAction);
                        this.resolveOptions(options);
                        this.initSelection();
                    }
                    /**
   * Defines base properties passed from constructor.
   * @param {Object} options
   */ _createClass(ClipboardAction, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = options.action;
                                this.container = options.container;
                                this.emitter = options.emitter;
                                this.target = options.target;
                                this.text = options.text;
                                this.trigger = options.trigger;
                                this.selectedText = "";
                            }
                        },
                        {
                            key: "initSelection",
                            value: function initSelection() {
                                if (this.text) this.selectFake();
                                else if (this.target) this.selectTarget();
                            }
                        },
                        {
                            key: "createFakeElement",
                            value: function createFakeElement() {
                                var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                                this.fakeElem = document.createElement("textarea"); // Prevent zooming on iOS
                                this.fakeElem.style.fontSize = "12pt"; // Reset box model
                                this.fakeElem.style.border = "0";
                                this.fakeElem.style.padding = "0";
                                this.fakeElem.style.margin = "0"; // Move element out of screen horizontally
                                this.fakeElem.style.position = "absolute";
                                this.fakeElem.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                                this.fakeElem.style.top = "".concat(yPosition, "px");
                                this.fakeElem.setAttribute("readonly", "");
                                this.fakeElem.value = this.text;
                                return this.fakeElem;
                            }
                        },
                        {
                            key: "selectFake",
                            value: function selectFake() {
                                var _this = this;
                                var fakeElem = this.createFakeElement();
                                this.fakeHandlerCallback = function() {
                                    return _this.removeFake();
                                };
                                this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || true;
                                this.container.appendChild(fakeElem);
                                this.selectedText = select_default()(fakeElem);
                                this.copyText();
                                this.removeFake();
                            }
                        },
                        {
                            key: "removeFake",
                            value: function removeFake() {
                                if (this.fakeHandler) {
                                    this.container.removeEventListener("click", this.fakeHandlerCallback);
                                    this.fakeHandler = null;
                                    this.fakeHandlerCallback = null;
                                }
                                if (this.fakeElem) {
                                    this.container.removeChild(this.fakeElem);
                                    this.fakeElem = null;
                                }
                            }
                        },
                        {
                            key: "selectTarget",
                            value: function selectTarget() {
                                this.selectedText = select_default()(this.target);
                                this.copyText();
                            }
                        },
                        {
                            key: "copyText",
                            value: function copyText() {
                                var succeeded;
                                try {
                                    succeeded = document.execCommand(this.action);
                                } catch (err) {
                                    succeeded = false;
                                }
                                this.handleResult(succeeded);
                            }
                        },
                        {
                            key: "handleResult",
                            value: function handleResult(succeeded) {
                                this.emitter.emit(succeeded ? "success" : "error", {
                                    action: this.action,
                                    text: this.selectedText,
                                    trigger: this.trigger,
                                    clearSelection: this.clearSelection.bind(this)
                                });
                            }
                        },
                        {
                            key: "clearSelection",
                            value: function clearSelection() {
                                if (this.trigger) this.trigger.focus();
                                document.activeElement.blur();
                                window.getSelection().removeAllRanges();
                            }
                        },
                        {
                            key: "destroy",
                            /**
     * Destroy lifecycle.
     */ value: function destroy() {
                                this.removeFake();
                            }
                        },
                        {
                            key: "action",
                            set: function set() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "copy";
                                this._action = action;
                                if (this._action !== "copy" && this._action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                            },
                            get: function get() {
                                return this._action;
                            }
                        },
                        {
                            key: "target",
                            set: function set(target) {
                                if (target !== undefined) {
                                    if (target && _typeof(target) === "object" && target.nodeType === 1) {
                                        if (this.action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                                        if (this.action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                                        this._target = target;
                                    } else throw new Error('Invalid "target" value, use a valid Element');
                                }
                            },
                            get: function get() {
                                return this._target;
                            }
                        }
                    ]);
                    return ClipboardAction;
                }();
                /* harmony default export */ var clipboard_action = ClipboardAction;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function clipboard_classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function clipboard_defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function clipboard_createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) clipboard_defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) clipboard_defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        clipboard_classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ clipboard_createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                if (this.clipboardAction) this.clipboardAction = null;
                                this.clipboardAction = new clipboard_action({
                                    action: this.action(trigger),
                                    target: this.target(trigger),
                                    text: this.text(trigger),
                                    container: this.container,
                                    trigger: trigger,
                                    emitter: this
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                                if (this.clipboardAction) {
                                    this.clipboardAction.destroy();
                                    this.clipboardAction = null;
                                }
                            }
                        }
                    ], [
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function destroy() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function destroy() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function destroy() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function on(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function once(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function emit(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function off(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function getter() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(134);
    /******/ }().default;
});


try {
    var $81ba149a4dfdc324$var$macy = Macy({
        container: ".masonry",
        trueOrder: false,
        waitForImages: false,
        margin: 6,
        columns: 3,
        breakAt: {
            940: 2,
            520: 1
        }
    });
} catch (any) {
// swallow
}
if ($(".print-only").length === 0) {
    $(".js-score-panel").css("opacity", "0");
    $(".js-score-panel").css("transform", "translateY(20%)");
    $(".js-gauge-container").css("transform", "translateX(100%)");
    $(".js-gauge-container").css("opacity", "0");
    $(".js-animate-up").css("opacity", "0");
    $(".js-animate-up").css("transform", "translateY(20%)");
    $(".js-fade-in").css("opacity", "0");
    var $81ba149a4dfdc324$var$controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
        offset: 10
    }).setClassToggle("nav.fixed", "compact-version").addTo($81ba149a4dfdc324$var$controller);
    new ScrollMagic.Scene({
        triggerElement: ".js-score-container",
        offset: "-200"
    }).on("enter", function() {
        var gaugeTimeline = anime.timeline({
            easing: "easeOutQuart",
            duration: 500
        });
        gaugeTimeline.add({
            delay: 1000,
            targets: ".js-score-panel",
            translateY: 0,
            opacity: 1
        }).add({
            targets: ".js-gauge-slide-in",
            delay: anime.stagger(250),
            translateX: 0,
            opacity: 1
        });
    }).on("leave", function() {}).addTo($81ba149a4dfdc324$var$controller);
    $(".js-trigger").each(function(i, match) {
        var uniqueClassName = "js-animate-trigger-" + i;
        $(match).addClass(uniqueClassName);
        new ScrollMagic.Scene({
            triggerElement: "." + uniqueClassName,
            duration: $(match).height(),
            triggerHook: 0.8
        }).on("enter", function() {
            anime.timeline({
                easing: "easeOutQuart",
                duration: 1500
            }).add({
                targets: "." + uniqueClassName + " .js-animate-up",
                translateY: 0,
                opacity: 1,
                complete: function complete(anim) {
                    $(".js-trigger-reset").css("overflow", "visible");
                }
            }, 400).add({
                targets: "." + uniqueClassName + " .js-fade-in",
                opacity: 1
            }, 300).add({
                duration: 300,
                targets: "." + uniqueClassName + " .glow",
                opacity: 1
            }, 200).add({
                duration: 300,
                targets: "." + uniqueClassName + " .glow-right",
                opacity: 1
            }, 200).add({
                duration: 300,
                targets: "." + uniqueClassName + " .glow-bottom",
                opacity: 1
            }, 200);
        }).addTo($81ba149a4dfdc324$var$controller);
    });
    /* Steps animation */ $(".js-animate-step").css("opacity", "0");
    $(".js-animate-step").css("transform", "translateY(50%)");
    $(".js-animate-steps-trigger").each(function(i, match) {
        var uniqueClassName = "js-animate-steps-" + i;
        $(match).addClass(uniqueClassName);
        new ScrollMagic.Scene({
            triggerElement: "." + uniqueClassName,
            duration: $(match).height(),
            triggerHook: 0.9
        }).on("enter", function() {
            anime.timeline({
                easing: "easeOutQuart",
                duration: 500
            }).add({
                targets: "." + uniqueClassName + " .js-animate-step",
                duration: 1000,
                delay: anime.stagger(200),
                translateY: 0,
                opacity: 1
            });
        }).addTo($81ba149a4dfdc324$var$controller);
    });
    /* Image switcher animation */ $(".js-animate-image-switch-trigger .js-animate-image-switch-target").each(function(i, match) {
        if (i > 0) $(match).css("opacity", "0");
    });
    $(".js-animate-image-switch-trigger").each(function(i, match) {
        var uniqueClassName = "js-animate-image-switch-trigger-" + i;
        $(match).addClass(uniqueClassName);
        $(match).find(".js-animate-image-switch").each(function(n, trigger) {
            var triggerClassName = "." + uniqueClassName + " .js-animate-image-switch-trigger-" + n;
            var targetClassName = "." + uniqueClassName + " .js-animate-image-switch-target-" + n;
            new ScrollMagic.Scene({
                triggerElement: triggerClassName,
                duration: $(trigger).height()
            }).on("enter", function() {
                anime.timeline({
                    easing: "easeOutQuart",
                    duration: 1000
                }).add({
                    targets: targetClassName,
                    opacity: 1
                });
            }).on("leave", function() {
                anime.timeline({
                    easing: "easeOutQuart",
                    duration: 1000
                }).add({
                    targets: targetClassName,
                    opacity: 0
                });
            }).addTo($81ba149a4dfdc324$var$controller);
        });
    });
}
window.supportsRange = function() {
    var input = document.createElement("input");
    input.setAttribute("type", "range");
    return input.type !== "text";
};
window.validateFormControls = function(parentId, message) {
    var valid = true;
    $("#" + parentId + " .message").addClass("hidden");
    $("#" + parentId).find("input").each(function() {
        if (this.checkValidity() === false) valid = false;
    });
    if (!valid) $("#" + parentId + " .message").removeClass("hidden").get(0).scrollIntoView();
    return valid;
};
window.locationAutocomplete = function() {
    $(function() {
        $(".js-location-autocomplete").each(function() {
            var completer = new google.maps.places.Autocomplete(this, {
                types: [
                    "(cities)"
                ],
                fields: [
                    "address_component"
                ]
            });
            google.maps.event.addListener(completer, "place_changed", function() {
                var chosen = completer.getPlace();
                var address = chosen.address_components;
                if (address) {
                    var country = address.find(function(f) {
                        return f.types.indexOf("country") !== -1;
                    }).short_name;
                    // GB level 1 is England/Scotland/Wales/Northern Ireland
                    // GB level 2 is a county
                    var stateField = country === "GB" ? "administrative_area_level_2" : "administrative_area_level_1";
                    $("input[autocomplete=city]").val(address.find(function(f) {
                        return f.types.indexOf("locality") !== -1;
                    }).short_name);
                    $("input[autocomplete=state]").val(address.find(function(f) {
                        return f.types.indexOf(stateField) !== -1;
                    }).short_name);
                    $("input[autocomplete=country]").val(country);
                }
            });
        });
    });
};
$(function() {
    $(".floating-select select").each(function(i, select) {
        var select = $(select);
        if (select.val() == "") select.parents(".floating-select").addClass("no-value-entered");
        else select.parents(".floating-select").addClass("value-entered");
    });
    $(".floating-select select").on("change", function(event) {
        var select = $(event.target);
        if (select.val() == "") {
            select.parents(".floating-select").addClass("no-value-entered");
            select.parents(".floating-select").removeClass("value-entered");
        } else {
            select.parents(".floating-select").addClass("value-entered");
            select.parents(".floating-select").removeClass("no-value-entered");
        }
    });
    $("li > span").each(function(i, span) {
        var className = $(span).attr("class");
        $(span).parents("ul").addClass(className);
    });
    $(".js-reset-page").on("click", function() {
        $("input[name=page]").val(1);
    });
    $(".homepage-links").each(function(i, match) {
        var waypoint = new Waypoint({
            element: match,
            offset: "100px",
            handler: function handler(direction) {
                if (direction === "down") $(match).find(".card").each(function(i, card) {
                    card.style.animation = "none";
                    card.offsetHeight // trigger reflow
                    ;
                    card.style.animation = null;
                });
            }
        });
    });
    $("[data-popup-link]").each(function(i, match) {
        $(match).attr("href", "#" + $(match).data("popup-link"));
    });
    $(".js-prevent-double-submit").on("submit", function(event) {
        var isDisabled = $(this).find("[aria-disabled]").length > 0;
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        // only disable if all the fields pass validation!
        if ($(this).find(":invalid").length === 0) $(".js-prevent-double-submit input[type=submit").attr("aria-disabled", true);
    });
    $(".waypoint-popup").each(function(i, match) {
        var waypoint = new Waypoint({
            element: match,
            offset: "-50%",
            handler: function handler(direction) {
                if ($(".delayed-popup").length == 0) return;
                if (direction === "down") {
                    $(".delayed-popup").get(0).dispatchEvent(new CustomEvent("open-me"));
                    waypoint.disable();
                }
            }
        });
    });
    $(".waypoint-popup-bottom").each(function(i, match) {
        var waypoint = new Waypoint({
            element: match,
            offset: "75%",
            handler: function handler(direction) {
                if ($(".delayed-popup-bottom").length == 0) return;
                if (direction === "down" && !$(".delayed-popup-bottom").hasClass("js-already-hidden")) {
                    $(".delayed-popup-bottom").get(0).dispatchEvent(new CustomEvent("open-me"));
                    waypoint.disable();
                }
            }
        });
    });
    $(".waypoint-close-gap").each(function(i, match) {
        var waypoint = new Waypoint({
            element: match,
            handler: function handler(direction) {
                if (direction === "down") $(".animate-close-gap").addClass("close-gap");
                else $(".animate-close-gap").removeClass("close-gap");
            }
        });
    });
    if ($(".glider").length > 0) {
        var glider = new Glider(document.querySelector(".glider"), {
            slidesToShow: 1,
            dots: ".dots",
            scrollLock: true,
            draggable: true
        });
        $(".glider-slide").removeClass("hidden");
        function autoplay(slider, miliseconds) {
            var slidesCount = slider.track.childElementCount;
            var slideTimeout = null;
            var nextIndex = 1;
            function slide() {
                slideTimeout = setTimeout(function() {
                    if (nextIndex >= slidesCount) nextIndex = 0;
                    slider.scrollItem(nextIndex++);
                }, miliseconds);
            }
            slider.ele.addEventListener("glider-animated", function() {
                window.clearInterval(slideTimeout);
                slide();
            });
            slide();
        }
        autoplay(glider, 5000);
    }
    $(".js-close").on("click", function(event) {
        event.preventDefault();
        var target = $(event.target).data("close-target");
        $(target).addClass("hidden");
        $(target).addClass("js-already-hidden");
    });
    // Refer a friend, client side validation and spinner magic.
    $(".js-referral-form").on("submit", function(_evt) {
        // is this a row of empty inputs?
        var isEmpty = function isEmpty(row) {
            var inputs = $(row).find("input");
            var empties = inputs.filter(function(_ix, ipt) {
                return ($(ipt).val() || "").length === 0;
            });
            return empties.length === inputs.length;
        };
        // is this a row with at least one empty input?
        var isIncomplete = function isIncomplete(row) {
            var inputs = $(row).find("input");
            var filled = inputs.filter(function(_ix, ipt) {
                return ($(ipt).val() || "").length > 0;
            });
            return filled.length < inputs.length;
        };
        // clear everything then recompute
        var list = $("div.js-rf-email-list");
        $(list).find(".js-rf-validation-min").addClass("hidden");
        $(list).find(".js-rf-validation").addClass("hidden");
        $(list).find("input").removeClass("border-red-500 rounded");
        var oneNeeded = true // make false if any non-empty found
        ;
        var anyIncomplete = false // make true if any incomplete found
        ;
        $(list).find(".js-rf-list-item").each(function(_ix, item) {
            var empty = isEmpty(item);
            var incomplete = isIncomplete(item);
            if (incomplete && !empty) {
                $(item).find(".js-rf-validation").removeClass("hidden");
                $(item).find("input").addClass("border-red-500 rounded");
            }
            oneNeeded &= empty;
            anyIncomplete |= incomplete && !empty;
        });
        if (oneNeeded) $(list).find(".js-rf-validation-min").removeClass("hidden");
        if (oneNeeded || anyIncomplete) return false // block submission
        ;
        $(".js-referral-submit").addClass("hidden").attr("disabled", true);
        $(".js-referral-spinner").removeClass("hidden");
        return true // let the flow continue
        ;
    });
    $(".scroller .js-scroll-left").on("click", function() {
        var container = $(this).parents(".scroller").find("ul").get(0);
        if (container) container.scrollBy({
            left: -250,
            behavior: "smooth"
        });
    });
    $(".scroller .js-scroll-right").on("click", function() {
        var container = $(this).parents(".scroller").find("ul").get(0);
        if (container) container.scrollBy({
            left: 250,
            behavior: "smooth"
        });
    });
    $(".smooth-scroll").on("click", function(event) {
        event.preventDefault();
        document.querySelector(this.getAttribute("href")).scrollIntoView({
            behavior: "smooth"
        });
    });
    // member discounts slice
    $(".js-discount-reveal").on("click", function(e) {
        e.preventDefault();
        var t = $(e.target);
        var p = t.parents(".js-discount-tile");
        p.find(".js-discount-reveal").addClass("hidden");
        p.find(".js-discount-text").removeClass("hidden");
        p.find(".js-discount-claim").removeClass("hidden");
        return false;
    });
    $(".score-gauge").each(function() {
        var _this = this;
        var score = parseInt($(this).data("score"));
        var initialScore = score;
        var min = parseInt($(this).data("min"));
        var max = parseInt($(this).data("max"));
        var thresholdAmber = parseInt($(this).data("threshold-amber")) || 0;
        var thresholdGreen = parseInt($(this).data("threshold-green")) || 0;
        var defaultColour = $(this).data("color") || "#B50E7d";
        var startAngle = parseFloat($(this).data("start-angle")) || -90;
        var endAngle = parseFloat($(this).data("end-angle")) || -90.01;
        var printMode = $(".print-only").length > 0;
        if (!printMode && score !== 0 && $(this).data("delay")) initialScore = 0;
        var gauge = new Gauge(this, {
            min: min,
            max: max,
            dialStartAngle: startAngle,
            dialEndAngle: endAngle,
            value: initialScore,
            showValue: false,
            color: function color(value) {
                if (!thresholdAmber && !thresholdGreen) return defaultColour;
                if (value < thresholdAmber) return "#ea324c";
                else if (value < thresholdGreen) return "#f2ac42";
                else return "#00b38a";
            }
        });
        if (!printMode && score != 0 && initialScore === 0) setTimeout(function() {
            gauge.setValueAnimated(score, 1);
            var timer = null;
            var currentScore = 0;
            var eachInterval = score / 100;
            timer = setInterval(function() {
                currentScore += eachInterval;
                if (currentScore > score) {
                    currentScore = score;
                    clearInterval(timer);
                }
                $(_this).parent(".st").find(".gauge-total").text(parseInt(currentScore));
            }, 10);
        }, 1000);
    });
    var event = new CustomEvent("gauges-rendered");
    document.dispatchEvent(event);
    var handler = function handler(event) {
        var parent = $(this).parents(".question");
        var value = Math.round(event.target.value);
        $(this).val(value);
        var options = $(this).data("options").split(",");
        var parsedValue = options[value];
        var match = $(this).parents(".question").find("input[value='".concat(parsedValue, "']"));
        match.prop("checked", true);
        var allLabels = parent.find(".js-survey-slider-label");
        var matchingLabel = $(parent.find(".js-survey-slider-label").get(value));
        allLabels.removeClass("active");
        matchingLabel.addClass("active");
    };
    $(".js-survey-slider").on("change", handler);
    $(".js-survey-slider").on("click", handler);
    $(".js-survey-slider-label").on("click", function(event) {
        var optionIndex = parseInt($(this).data("index"));
        var slider = $(this).parents(".question").find(".js-survey-slider");
        slider.val(optionIndex);
        var options = slider.data("options").split(",");
        var parsedValue = options[optionIndex];
        var match = $(this).parents(".question").find("input[value='".concat(parsedValue, "']"));
        $(this).parents(".question").find(".js-survey-slider-label").removeClass("active");
        $(this).addClass("active");
        match.prop("checked", true);
    });
    $(".radar-plot").each(function() {
        var scores = $(this).data("scores");
        var keys = scores.map(function(s) {
            return s.label;
        });
        var values = scores.map(function(s) {
            return s.score;
        });
        // add first plot again to end
        keys.push(scores[0].label);
        values.push(scores[0].score);
        var radarData = [
            {
                type: "scatterpolar",
                r: values,
                theta: keys,
                fill: "toself",
                line: {
                    shape: "spline"
                }
            }
        ];
        var radarLayout = {
            polar: {
                radialaxis: {
                    visible: false,
                    showticklabels: false,
                    linewidth: 0,
                    ticklen: 0,
                    range: [
                        0,
                        25
                    ]
                },
                angularaxis: {
                    visible: true,
                    rotation: 135,
                    direction: "clockwise",
                    gridwidth: 2,
                    gridcolor: "#fff",
                    showline: false,
                    showticklabels: false,
                    ticks: ""
                }
            },
            showlegend: false,
            margin: {
                b: 0,
                t: 0,
                l: 0,
                r: 0
            },
            paper_bgcolor: "rgba(0,0,0,0)",
            plot_bgcolor: "rgba(0,0,0,0)",
            colorway: [
                "#B50E7D"
            ]
        };
        var plot = Plotly.newPlot($(this).get(0), radarData, radarLayout, {
            staticPlot: true,
            responsive: true
        });
        Plotly.Plots.resize($(this).get(0));
    });
    $("#js-trigger-loading").each(function() {
        var action = $(this).data("url");
        var headers = new Headers();
        headers.set("Accept", "application/json");
        fetch(action, {
            headers: headers
        }).then(function(r) {
            return r.json();
        }).then(function(j) {
            return window.location = j.go;
        });
    });
    new (0, (/*@__PURE__*/$parcel$interopDefault($c8f70d1a332681e9$exports)))(".copy-to-clipboard");
});


/** CLient-side validation for custom contact forms. */ $(function() {
    var revalidateInput = function revalidateInput(input) {
        try {
            var siblingMessages = $(input).siblings(".js-validate-message");
            var thisInputIsValid = input.checkValidity();
            if (thisInputIsValid) {
                $(input).removeClass("checked-invalid");
                siblingMessages.hide();
            } else {
                $(input).addClass("checked-invalid");
                siblingMessages.show();
                input.reportValidity();
            }
            return thisInputIsValid;
        } catch (err) {
            console.warn("revalidateInput", err);
            return false;
        }
    };
    var revalidateRadioButtonGroup = function revalidateRadioButtonGroup(group) {
        try {
            var checks = [];
            $(group).find("input").map(function(_ix, input) {
                checks.push(input.checkValidity());
            });
            var anyValid = checks.length === 0 || checks.some(function(t) {
                return t;
            });
            if (anyValid) $(group).find(".js-validate-message").hide();
            else $(group).find(".js-validate-message").show();
            return anyValid;
        } catch (err) {
            console.warn("revalidateRadioButtonGroup", err);
            return false;
        }
    };
    $("form.js-custom-form .js-validate").on("change", function(event) {
        revalidateInput($(event.target).first()[0]);
    });
    $("form.js-custom-form .js-validate-radio input").on("change", function(event) {
        var group = $(event.target).closest(".js-validate-radio").first()[0];
        if (group) revalidateRadioButtonGroup(group);
    });
    /** Run these as a background POST for time-consuming work. */ $("form.js-contact-form-background").on("submit", function(e) {
        e.preventDefault();
        var form = $(e.target);
        var where = form.attr("action");
        var data = form.serialize();
        form.find(".js-contact-form-spinner").removeClass("hidden");
        fetch(where, {
            method: "POST",
            body: data,
            // redirect: "follow",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json"
            }
        }).then(function(response) {
            return response.json();
        }).then(function(response) {
            window.location = response.url;
        }).catch(function(err) {
            console.warn(err);
            form.find(".js-contact-form-spinner").addClass("hidden");
        });
        return false;
    });
});


/**
 * Set up sharing and favourite-article toggle buttons.
 *
 * See the 'share.pug' mixin.
 *
 * (It's either DOM access and for-loops, or bundling JQuery for a few calls.)
 */ 
window.addEventListener("load", function() {
    // SHARE BUTTON
    new (0, (/*@__PURE__*/$parcel$interopDefault($c8f70d1a332681e9$exports)))("button.js-share-link");
    // FAVOURITES
    // a) Inside these click listeners:
    //    - 'this' is the listener object,
    //    - event.target is the click receiver, *not* necessarily the listener.
    // b) The article is a favourite by the value of data-item-favourite
    //    (as dataset.itemFavourite) with the **literal words** 'true' and 'false'.
    // c) The article id itself is accessible as data-item-id / dataset.itemId.
    // d) The buttons are toggled betwen add/remove optimistically without waiting
    //    for the back-end process, which can be pretty slow.
    var adders = this.document.getElementsByClassName("js-favourite-add");
    var removers = this.document.getElementsByClassName("js-favourite-remove");
    var showItems = function showItems(aList /* of elements */ ) {
        toggleItems(aList, true);
    };
    var hideItems = function hideItems(aList /* of elements */ ) {
        toggleItems(aList, false);
    };
    var toggleItems = function toggleItems(aList /* of elements */ , setVisible /* boolean */ ) {
        for(var i = 0; i < aList.length; i++)if (setVisible) aList[i].classList.remove("hidden");
        else aList[i].classList.add("hidden");
    };
    for(var i = 0; i < adders.length; i++)adders[i].addEventListener("click", function(event) {
        event.preventDefault();
        // optimistically switch the button and let the back-end process happen
        hideItems(adders);
        showItems(removers);
        var id = this.dataset.itemId;
        if (id) fetch("/users/favourite/".concat(id), {
            method: "PUT"
        }).then(function() {
            return null;
        }).catch(function(err) {
            console.warn(err);
        });
        return false;
    });
    for(var i = 0; i < removers.length; i++)removers[i].addEventListener("click", function(event) {
        event.preventDefault();
        // optimistically switch the button and let the back-end process happen
        hideItems(removers);
        showItems(adders);
        var id = this.dataset.itemId;
        if (id) fetch("/users/favourite/".concat(id), {
            method: "DELETE"
        }).then(function() {
            return null;
        }).catch(function(err) {
            console.warn(err);
        });
        return false;
    });
});


/**
 * Integrations which trigger a self-hosted form, as opposed to Calendly.
 *
 * Show the modal,
 * fetch the inner form in the background,
 * shove it in the placeholder.
 */ $(function() {
    $("a.js-integration-trigger").on("click tap", function(e) {
        e.preventDefault();
        var targetModal = $("#js-integration-modal");
        if (targetModal) {
            // show placeholder
            targetModal.removeClass("hidden");
            // fetch local content and replace the placeholder
            var contentLink = $(e.target).attr("href");
            if (contentLink) fetch(contentLink).then(function(response) {
                return response.text();
            }).then(function(html) {
                var container = targetModal.find(".js-modal-content");
                targetModal.find(".js-modal-loading").addClass("hidden");
                $("body").addClass("overflow-hidden");
                var wrapper = $("<div>").addClass("js-modal-wrapper");
                wrapper.append($(html));
                container.append(wrapper);
                var doCancel = function doCancel(canx) {
                    canx.preventDefault();
                    targetModal.find(".js-modal-wrapper").remove();
                    targetModal.find(".js-modal-loading").removeClass("hidden");
                    targetModal.addClass("hidden");
                    $("body").removeClass("overflow-hidden");
                    return false;
                };
                // the cancel button might not have existed until the form appeared
                $(".js-modal-cancel").on("click tap", doCancel);
                targetModal.find("form").on("keyup", function(canx) {
                    return canx.key === "Escape" ? doCancel(canx) : true;
                });
                // wire up the form handler so that we can replace the
                // modal content with the outcome of booking
                $("form.js-self-hosted-booking").on("submit", function(e) {
                    e.preventDefault();
                    targetModal.children(".js-modal-loading").addClass("hidden");
                    wrapper.children(".js-modal-complete").addClass("hidden");
                    wrapper.children(".js-modal-failed").addClass("hidden");
                    var form = $(e.target);
                    var where = form.attr("action");
                    var data = form.serialize();
                    console.log("Posting", data, "to", where);
                    fetch(where, {
                        method: "POST",
                        body: data,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    }).then(function(response) {
                        form.addClass("hidden");
                        if (response.ok) wrapper.children(".js-modal-complete").removeClass("hidden");
                        else wrapper.children(".js-modal-failed").removeClass("hidden");
                    }).catch(function(err) {
                        console.warn(err);
                        form.addClass("hidden");
                        wrapper.children(".js-modal-complete").addClass("hidden");
                        wrapper.children(".js-modal-failed").removeClass("hidden");
                    });
                });
            }).catch(function(err) {
                console.warn(err);
                targetModal.addClass("hidden");
            });
        }
        return false;
    });
});


// polyfilled for IE11
var $cc41b945fd7849be$exports = {};
var $20677542c7d32647$exports = {};
var $744bc9442daea4b8$exports = {};
var $6848962f6bdacda0$exports = {};
"use strict";
var $fda6dfb98eaa3934$exports = {};
"use strict";
var $9509281219407356$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $5bdc3bfa96892a98$exports = {};
var $9785bc7eee705f57$exports = {};
var $9785bc7eee705f57$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$9785bc7eee705f57$exports = // eslint-disable-next-line es/no-global-this -- safe
$9785bc7eee705f57$var$check(typeof globalThis == "object" && globalThis) || $9785bc7eee705f57$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$9785bc7eee705f57$var$check(typeof self == "object" && self) || $9785bc7eee705f57$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $e96b4307caf506f9$exports = {};
var $e96b4307caf506f9$var$FunctionPrototype = Function.prototype;
var $e96b4307caf506f9$var$bind = $e96b4307caf506f9$var$FunctionPrototype.bind;
var $e96b4307caf506f9$var$call = $e96b4307caf506f9$var$FunctionPrototype.call;
var $e96b4307caf506f9$var$callBind = $e96b4307caf506f9$var$bind && $e96b4307caf506f9$var$bind.bind($e96b4307caf506f9$var$call);
$e96b4307caf506f9$exports = $e96b4307caf506f9$var$bind ? function(fn) {
    return fn && $e96b4307caf506f9$var$callBind($e96b4307caf506f9$var$call, fn);
} : function(fn) {
    return fn && function() {
        return $e96b4307caf506f9$var$call.apply(fn, arguments);
    };
};


var $38b87967b8795bbc$exports = {};
$38b87967b8795bbc$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


var $cff35349a081683c$exports = {};

var $cff35349a081683c$var$toString = $e96b4307caf506f9$exports({}.toString);
var $cff35349a081683c$var$stringSlice = $e96b4307caf506f9$exports("".slice);
$cff35349a081683c$exports = function(it) {
    return $cff35349a081683c$var$stringSlice($cff35349a081683c$var$toString(it), 8, -1);
};


var $5bdc3bfa96892a98$var$Object = $9785bc7eee705f57$exports.Object;
var $5bdc3bfa96892a98$var$split = $e96b4307caf506f9$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$5bdc3bfa96892a98$exports = $38b87967b8795bbc$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$5bdc3bfa96892a98$var$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $cff35349a081683c$exports(it) == "String" ? $5bdc3bfa96892a98$var$split(it, "") : $5bdc3bfa96892a98$var$Object(it);
} : $5bdc3bfa96892a98$var$Object;


var $ad5205f5712371b7$exports = {};

var $ad5205f5712371b7$var$TypeError = $9785bc7eee705f57$exports.TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ad5205f5712371b7$exports = function(it) {
    if (it == undefined) throw $ad5205f5712371b7$var$TypeError("Can't call method on " + it);
    return it;
};


$9509281219407356$exports = function(it) {
    return $5bdc3bfa96892a98$exports($ad5205f5712371b7$exports(it));
};


var $6748bb1d887031b0$exports = {};
var $e2a74cbbd6f86b5b$exports = {};

var $29cccbf8be700fab$exports = {};
var $f68ec07cf86795a8$exports = {};
$f68ec07cf86795a8$exports = false;


var $75c9cf41835cb887$exports = {};

var $7f3ab6b2787fa7d1$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7f3ab6b2787fa7d1$var$defineProperty = Object.defineProperty;
$7f3ab6b2787fa7d1$exports = function(key, value) {
    try {
        $7f3ab6b2787fa7d1$var$defineProperty($9785bc7eee705f57$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $9785bc7eee705f57$exports[key] = value;
    }
    return value;
};


var $75c9cf41835cb887$var$SHARED = "__core-js_shared__";
var $75c9cf41835cb887$var$store = $9785bc7eee705f57$exports[$75c9cf41835cb887$var$SHARED] || $7f3ab6b2787fa7d1$exports($75c9cf41835cb887$var$SHARED, {});
$75c9cf41835cb887$exports = $75c9cf41835cb887$var$store;


($29cccbf8be700fab$exports = function(key, value) {
    return $75c9cf41835cb887$exports[key] || ($75c9cf41835cb887$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.19.0",
    mode: $f68ec07cf86795a8$exports ? "pure" : "global",
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});


var $f886a2c1b39b3cb3$exports = {};

var $a6a78d3ed911f53c$exports = {};


var $a6a78d3ed911f53c$var$Object = $9785bc7eee705f57$exports.Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a6a78d3ed911f53c$exports = function(argument) {
    return $a6a78d3ed911f53c$var$Object($ad5205f5712371b7$exports(argument));
};


var $f886a2c1b39b3cb3$var$hasOwnProperty = $e96b4307caf506f9$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
$f886a2c1b39b3cb3$exports = Object.hasOwn || function hasOwn(it, key) {
    return $f886a2c1b39b3cb3$var$hasOwnProperty($a6a78d3ed911f53c$exports(it), key);
};


var $fc27cc19dc286a80$exports = {};

var $fc27cc19dc286a80$var$id = 0;
var $fc27cc19dc286a80$var$postfix = Math.random();
var $fc27cc19dc286a80$var$toString = $e96b4307caf506f9$exports(1.0.toString);
$fc27cc19dc286a80$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $fc27cc19dc286a80$var$toString(++$fc27cc19dc286a80$var$id + $fc27cc19dc286a80$var$postfix, 36);
};


var $55072d2605c15db7$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $964a1d547c85d262$exports = {};

var $a9c0048938179bc6$exports = {};
var $6a795625cd8d5ee1$exports = {};

var $0f655c465e686369$exports = {};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$0f655c465e686369$exports = function(argument) {
    return typeof argument == "function";
};


var $6a795625cd8d5ee1$var$aFunction = function aFunction(argument) {
    return $0f655c465e686369$exports(argument) ? argument : undefined;
};
$6a795625cd8d5ee1$exports = function(namespace, method) {
    return arguments.length < 2 ? $6a795625cd8d5ee1$var$aFunction($9785bc7eee705f57$exports[namespace]) : $9785bc7eee705f57$exports[namespace] && $9785bc7eee705f57$exports[namespace][method];
};


$a9c0048938179bc6$exports = $6a795625cd8d5ee1$exports("navigator", "userAgent") || "";


var $964a1d547c85d262$var$process = $9785bc7eee705f57$exports.process;
var $964a1d547c85d262$var$Deno = $9785bc7eee705f57$exports.Deno;
var $964a1d547c85d262$var$versions = $964a1d547c85d262$var$process && $964a1d547c85d262$var$process.versions || $964a1d547c85d262$var$Deno && $964a1d547c85d262$var$Deno.version;
var $964a1d547c85d262$var$v8 = $964a1d547c85d262$var$versions && $964a1d547c85d262$var$versions.v8;
var $964a1d547c85d262$var$match, $964a1d547c85d262$var$version;
if ($964a1d547c85d262$var$v8) {
    $964a1d547c85d262$var$match = $964a1d547c85d262$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $964a1d547c85d262$var$version = $964a1d547c85d262$var$match[0] > 0 && $964a1d547c85d262$var$match[0] < 4 ? 1 : +($964a1d547c85d262$var$match[0] + $964a1d547c85d262$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$964a1d547c85d262$var$version && $a9c0048938179bc6$exports) {
    $964a1d547c85d262$var$match = $a9c0048938179bc6$exports.match(/Edge\/(\d+)/);
    if (!$964a1d547c85d262$var$match || $964a1d547c85d262$var$match[1] >= 74) {
        $964a1d547c85d262$var$match = $a9c0048938179bc6$exports.match(/Chrome\/(\d+)/);
        if ($964a1d547c85d262$var$match) $964a1d547c85d262$var$version = +$964a1d547c85d262$var$match[1];
    }
}
$964a1d547c85d262$exports = $964a1d547c85d262$var$version;



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$55072d2605c15db7$exports = !!Object.getOwnPropertySymbols && !$38b87967b8795bbc$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $964a1d547c85d262$exports && $964a1d547c85d262$exports < 41;
});


var $6d27a5e67c438de6$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ function $f33cb39429247b78$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}



$6d27a5e67c438de6$exports = $55072d2605c15db7$exports && !Symbol.sham && (0, $f33cb39429247b78$export$5f0017c582d45a2d)(Symbol.iterator) == "symbol";


var $e2a74cbbd6f86b5b$var$WellKnownSymbolsStore = $29cccbf8be700fab$exports("wks");
var $e2a74cbbd6f86b5b$var$Symbol = $9785bc7eee705f57$exports.Symbol;
var $e2a74cbbd6f86b5b$var$symbolFor = $e2a74cbbd6f86b5b$var$Symbol && $e2a74cbbd6f86b5b$var$Symbol["for"];
var $e2a74cbbd6f86b5b$var$createWellKnownSymbol = $6d27a5e67c438de6$exports ? $e2a74cbbd6f86b5b$var$Symbol : $e2a74cbbd6f86b5b$var$Symbol && $e2a74cbbd6f86b5b$var$Symbol.withoutSetter || $fc27cc19dc286a80$exports;
$e2a74cbbd6f86b5b$exports = function(name) {
    if (!$f886a2c1b39b3cb3$exports($e2a74cbbd6f86b5b$var$WellKnownSymbolsStore, name) || !($55072d2605c15db7$exports || typeof $e2a74cbbd6f86b5b$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($55072d2605c15db7$exports && $f886a2c1b39b3cb3$exports($e2a74cbbd6f86b5b$var$Symbol, name)) $e2a74cbbd6f86b5b$var$WellKnownSymbolsStore[name] = $e2a74cbbd6f86b5b$var$Symbol[name];
        else if ($6d27a5e67c438de6$exports && $e2a74cbbd6f86b5b$var$symbolFor) $e2a74cbbd6f86b5b$var$WellKnownSymbolsStore[name] = $e2a74cbbd6f86b5b$var$symbolFor(description);
        else $e2a74cbbd6f86b5b$var$WellKnownSymbolsStore[name] = $e2a74cbbd6f86b5b$var$createWellKnownSymbol(description);
    }
    return $e2a74cbbd6f86b5b$var$WellKnownSymbolsStore[name];
};


var $aed245c788e3388d$exports = {};
/* global ActiveXObject -- old IE, WSH */ var $26044fb63f4c2e37$exports = {};

var $8cb6fbe8e2a19881$exports = {};

$8cb6fbe8e2a19881$exports = function(it) {
    return typeof it == "object" ? it !== null : $0f655c465e686369$exports(it);
};


var $26044fb63f4c2e37$var$String = $9785bc7eee705f57$exports.String;
var $26044fb63f4c2e37$var$TypeError = $9785bc7eee705f57$exports.TypeError;
// `Assert: Type(argument) is Object`
$26044fb63f4c2e37$exports = function(argument) {
    if ($8cb6fbe8e2a19881$exports(argument)) return argument;
    throw $26044fb63f4c2e37$var$TypeError($26044fb63f4c2e37$var$String(argument) + " is not an object");
};


var $3157e86efe959573$exports = {};
var $20523523a5693ba2$exports = {};

// Detect IE8's incomplete defineProperty implementation
$20523523a5693ba2$exports = !$38b87967b8795bbc$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $20cd9102a9945d8c$export$2d1720544b23b823;


var $fe4ab78356ccf25d$exports = {};


var $487e3947e385675d$exports = {};


var $487e3947e385675d$var$document = $9785bc7eee705f57$exports.document;
// typeof document.createElement is 'object' in old IE
var $487e3947e385675d$var$EXISTS = $8cb6fbe8e2a19881$exports($487e3947e385675d$var$document) && $8cb6fbe8e2a19881$exports($487e3947e385675d$var$document.createElement);
$487e3947e385675d$exports = function(it) {
    return $487e3947e385675d$var$EXISTS ? $487e3947e385675d$var$document.createElement(it) : {};
};


// Thank's IE8 for his funny defineProperty
$fe4ab78356ccf25d$exports = !$20523523a5693ba2$exports && !$38b87967b8795bbc$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($487e3947e385675d$exports("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});



var $0ae3eac2c7ae6b04$exports = {};
var $42900924d53e81a4$exports = {};

var $aac63ddfd5f198a9$exports = {};
var $aac63ddfd5f198a9$var$call = Function.prototype.call;
$aac63ddfd5f198a9$exports = $aac63ddfd5f198a9$var$call.bind ? $aac63ddfd5f198a9$var$call.bind($aac63ddfd5f198a9$var$call) : function() {
    return $aac63ddfd5f198a9$var$call.apply($aac63ddfd5f198a9$var$call, arguments);
};



var $4c9211d2bd60ec38$exports = {};




var $41450826f1ceeca0$exports = {};

$41450826f1ceeca0$exports = $e96b4307caf506f9$exports({}.isPrototypeOf);



var $4c9211d2bd60ec38$var$Object = $9785bc7eee705f57$exports.Object;
$4c9211d2bd60ec38$exports = $6d27a5e67c438de6$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $f33cb39429247b78$export$5f0017c582d45a2d)(it)) == "symbol";
} : function(it) {
    var $Symbol = $6a795625cd8d5ee1$exports("Symbol");
    return $0f655c465e686369$exports($Symbol) && $41450826f1ceeca0$exports($Symbol.prototype, $4c9211d2bd60ec38$var$Object(it));
};


var $5e81212a58ed98da$exports = {};
var $d1496995914f9bc8$exports = {};


var $4dbad185c1fa7cd5$exports = {};

var $4dbad185c1fa7cd5$var$String = $9785bc7eee705f57$exports.String;
$4dbad185c1fa7cd5$exports = function(argument) {
    try {
        return $4dbad185c1fa7cd5$var$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $d1496995914f9bc8$var$TypeError = $9785bc7eee705f57$exports.TypeError;
// `Assert: IsCallable(argument) is true`
$d1496995914f9bc8$exports = function(argument) {
    if ($0f655c465e686369$exports(argument)) return argument;
    throw $d1496995914f9bc8$var$TypeError($4dbad185c1fa7cd5$exports(argument) + " is not a function");
};


// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$5e81212a58ed98da$exports = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $d1496995914f9bc8$exports(func);
};


var $7496c86162b6d752$exports = {};




var $7496c86162b6d752$var$TypeError = $9785bc7eee705f57$exports.TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$7496c86162b6d752$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $0f655c465e686369$exports(fn = input.toString) && !$8cb6fbe8e2a19881$exports(val = $aac63ddfd5f198a9$exports(fn, input))) return val;
    if ($0f655c465e686369$exports(fn = input.valueOf) && !$8cb6fbe8e2a19881$exports(val = $aac63ddfd5f198a9$exports(fn, input))) return val;
    if (pref !== "string" && $0f655c465e686369$exports(fn = input.toString) && !$8cb6fbe8e2a19881$exports(val = $aac63ddfd5f198a9$exports(fn, input))) return val;
    throw $7496c86162b6d752$var$TypeError("Can't convert object to primitive value");
};



var $42900924d53e81a4$var$TypeError = $9785bc7eee705f57$exports.TypeError;
var $42900924d53e81a4$var$TO_PRIMITIVE = $e2a74cbbd6f86b5b$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$42900924d53e81a4$exports = function(input, pref) {
    if (!$8cb6fbe8e2a19881$exports(input) || $4c9211d2bd60ec38$exports(input)) return input;
    var exoticToPrim = $5e81212a58ed98da$exports(input, $42900924d53e81a4$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $aac63ddfd5f198a9$exports(exoticToPrim, input, pref);
        if (!$8cb6fbe8e2a19881$exports(result) || $4c9211d2bd60ec38$exports(result)) return result;
        throw $42900924d53e81a4$var$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $7496c86162b6d752$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$0ae3eac2c7ae6b04$exports = function(argument) {
    var key = $42900924d53e81a4$exports(argument, "string");
    return $4c9211d2bd60ec38$exports(key) ? key : key + "";
};


var $20cd9102a9945d8c$var$TypeError = $9785bc7eee705f57$exports.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $20cd9102a9945d8c$var$$defineProperty = Object.defineProperty;
$20cd9102a9945d8c$export$2d1720544b23b823 = $20523523a5693ba2$exports ? $20cd9102a9945d8c$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $26044fb63f4c2e37$exports(O);
    P = $0ae3eac2c7ae6b04$exports(P);
    $26044fb63f4c2e37$exports(Attributes);
    if ($fe4ab78356ccf25d$exports) try {
        return $20cd9102a9945d8c$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $20cd9102a9945d8c$var$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};




var $32f837dd54d791a6$exports = {};
var $bfd6868c7ce43922$exports = {};



var $9a9e094cf8305f6b$exports = {};

var $8935439f7656ae2c$exports = {};
var $d7929eea7f09ee32$exports = {};
var $d7929eea7f09ee32$var$ceil = Math.ceil;
var $d7929eea7f09ee32$var$floor = Math.floor;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$d7929eea7f09ee32$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- safe
    return number !== number || number === 0 ? 0 : (number > 0 ? $d7929eea7f09ee32$var$floor : $d7929eea7f09ee32$var$ceil)(number);
};


var $8935439f7656ae2c$var$max = Math.max;
var $8935439f7656ae2c$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$8935439f7656ae2c$exports = function(index, length) {
    var integer = $d7929eea7f09ee32$exports(index);
    return integer < 0 ? $8935439f7656ae2c$var$max(integer + length, 0) : $8935439f7656ae2c$var$min(integer, length);
};


var $b94f205d951cc40c$exports = {};
var $d184a4b23b0212ee$exports = {};

var $d184a4b23b0212ee$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d184a4b23b0212ee$exports = function(argument) {
    return argument > 0 ? $d184a4b23b0212ee$var$min($d7929eea7f09ee32$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$b94f205d951cc40c$exports = function(obj) {
    return $d184a4b23b0212ee$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $9a9e094cf8305f6b$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $9509281219407356$exports($this);
        var length = $b94f205d951cc40c$exports(O);
        var index = $8935439f7656ae2c$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$9a9e094cf8305f6b$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $9a9e094cf8305f6b$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $9a9e094cf8305f6b$var$createMethod(false)
};


var $bfd6868c7ce43922$require$indexOf = $9a9e094cf8305f6b$exports.indexOf;
var $406d251f3e123e25$exports = {};
$406d251f3e123e25$exports = {};


var $bfd6868c7ce43922$var$push = $e96b4307caf506f9$exports([].push);
$bfd6868c7ce43922$exports = function(object, names) {
    var O = $9509281219407356$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$f886a2c1b39b3cb3$exports($406d251f3e123e25$exports, key) && $f886a2c1b39b3cb3$exports(O, key) && $bfd6868c7ce43922$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($f886a2c1b39b3cb3$exports(O, key = names[i++])) ~$bfd6868c7ce43922$require$indexOf(result, key) || $bfd6868c7ce43922$var$push(result, key);
    return result;
};


var $0cb6c18da4640278$exports = {};
// IE8- don't enum bug keys
$0cb6c18da4640278$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$32f837dd54d791a6$exports = Object.keys || function keys(O) {
    return $bfd6868c7ce43922$exports(O, $0cb6c18da4640278$exports);
};


// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$3157e86efe959573$exports = $20523523a5693ba2$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $26044fb63f4c2e37$exports(O);
    var props = $9509281219407356$exports(Properties);
    var keys = $32f837dd54d791a6$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$20cd9102a9945d8c$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $75b89ecffe4471d9$exports = {};

$75b89ecffe4471d9$exports = $6a795625cd8d5ee1$exports("document", "documentElement");



var $9edb78de2fa57a5b$exports = {};


var $9edb78de2fa57a5b$var$keys = $29cccbf8be700fab$exports("keys");
$9edb78de2fa57a5b$exports = function(key) {
    return $9edb78de2fa57a5b$var$keys[key] || ($9edb78de2fa57a5b$var$keys[key] = $fc27cc19dc286a80$exports(key));
};


var $aed245c788e3388d$var$GT = ">";
var $aed245c788e3388d$var$LT = "<";
var $aed245c788e3388d$var$PROTOTYPE = "prototype";
var $aed245c788e3388d$var$SCRIPT = "script";
var $aed245c788e3388d$var$IE_PROTO = $9edb78de2fa57a5b$exports("IE_PROTO");
var $aed245c788e3388d$var$EmptyConstructor = function EmptyConstructor() {};
var $aed245c788e3388d$var$scriptTag = function scriptTag(content) {
    return $aed245c788e3388d$var$LT + $aed245c788e3388d$var$SCRIPT + $aed245c788e3388d$var$GT + content + $aed245c788e3388d$var$LT + "/" + $aed245c788e3388d$var$SCRIPT + $aed245c788e3388d$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $aed245c788e3388d$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($aed245c788e3388d$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $aed245c788e3388d$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $487e3947e385675d$exports("iframe");
    var JS = "java" + $aed245c788e3388d$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $75b89ecffe4471d9$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($aed245c788e3388d$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $aed245c788e3388d$var$activeXDocument;
var $aed245c788e3388d$var$NullProtoObject = function NullProtoObject1() {
    try {
        $aed245c788e3388d$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $aed245c788e3388d$var$NullProtoObject = typeof document != "undefined" ? document.domain && $aed245c788e3388d$var$activeXDocument ? $aed245c788e3388d$var$NullProtoObjectViaActiveX($aed245c788e3388d$var$activeXDocument) // old IE
     : $aed245c788e3388d$var$NullProtoObjectViaIFrame() : $aed245c788e3388d$var$NullProtoObjectViaActiveX($aed245c788e3388d$var$activeXDocument); // WSH
    var length = $0cb6c18da4640278$exports.length;
    while(length--)delete $aed245c788e3388d$var$NullProtoObject[$aed245c788e3388d$var$PROTOTYPE][$0cb6c18da4640278$exports[length]];
    return $aed245c788e3388d$var$NullProtoObject();
};
$406d251f3e123e25$exports[$aed245c788e3388d$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$aed245c788e3388d$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $aed245c788e3388d$var$EmptyConstructor[$aed245c788e3388d$var$PROTOTYPE] = $26044fb63f4c2e37$exports(O);
        result = new $aed245c788e3388d$var$EmptyConstructor();
        $aed245c788e3388d$var$EmptyConstructor[$aed245c788e3388d$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$aed245c788e3388d$var$IE_PROTO] = O;
    } else result = $aed245c788e3388d$var$NullProtoObject();
    return Properties === undefined ? result : $3157e86efe959573$exports(result, Properties);
};



var $6748bb1d887031b0$var$UNSCOPABLES = $e2a74cbbd6f86b5b$exports("unscopables");
var $6748bb1d887031b0$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($6748bb1d887031b0$var$ArrayPrototype[$6748bb1d887031b0$var$UNSCOPABLES] == undefined) $20cd9102a9945d8c$export$2d1720544b23b823($6748bb1d887031b0$var$ArrayPrototype, $6748bb1d887031b0$var$UNSCOPABLES, {
    configurable: true,
    value: $aed245c788e3388d$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$6748bb1d887031b0$exports = function(key) {
    $6748bb1d887031b0$var$ArrayPrototype[$6748bb1d887031b0$var$UNSCOPABLES][key] = true;
};


var $f7225a60e3548728$exports = {};
$f7225a60e3548728$exports = {};


var $365673d13dbb7436$exports = {};
var $72f362e75e9fbc0c$exports = {};


var $927f93300a754aec$exports = {};



var $927f93300a754aec$var$functionToString = $e96b4307caf506f9$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$0f655c465e686369$exports($75c9cf41835cb887$exports.inspectSource)) $75c9cf41835cb887$exports.inspectSource = function(it) {
    return $927f93300a754aec$var$functionToString(it);
};
$927f93300a754aec$exports = $75c9cf41835cb887$exports.inspectSource;


var $72f362e75e9fbc0c$var$WeakMap = $9785bc7eee705f57$exports.WeakMap;
$72f362e75e9fbc0c$exports = $0f655c465e686369$exports($72f362e75e9fbc0c$var$WeakMap) && /native code/.test($927f93300a754aec$exports($72f362e75e9fbc0c$var$WeakMap));





var $289275360326f1a2$exports = {};


var $fab109c800ab897b$exports = {};
$fab109c800ab897b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$289275360326f1a2$exports = $20523523a5693ba2$exports ? function(object, key, value) {
    return $20cd9102a9945d8c$export$2d1720544b23b823(object, key, $fab109c800ab897b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};






var $365673d13dbb7436$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $365673d13dbb7436$var$TypeError = $9785bc7eee705f57$exports.TypeError;
var $365673d13dbb7436$var$WeakMap = $9785bc7eee705f57$exports.WeakMap;
var $365673d13dbb7436$var$set, $365673d13dbb7436$var$get, $365673d13dbb7436$var$has;
var $365673d13dbb7436$var$enforce = function enforce(it) {
    return $365673d13dbb7436$var$has(it) ? $365673d13dbb7436$var$get(it) : $365673d13dbb7436$var$set(it, {});
};
var $365673d13dbb7436$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$8cb6fbe8e2a19881$exports(it) || (state = $365673d13dbb7436$var$get(it)).type !== TYPE) throw $365673d13dbb7436$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($72f362e75e9fbc0c$exports || $75c9cf41835cb887$exports.state) {
    var $365673d13dbb7436$var$store = $75c9cf41835cb887$exports.state || ($75c9cf41835cb887$exports.state = new $365673d13dbb7436$var$WeakMap());
    var $365673d13dbb7436$var$wmget = $e96b4307caf506f9$exports($365673d13dbb7436$var$store.get);
    var $365673d13dbb7436$var$wmhas = $e96b4307caf506f9$exports($365673d13dbb7436$var$store.has);
    var $365673d13dbb7436$var$wmset = $e96b4307caf506f9$exports($365673d13dbb7436$var$store.set);
    $365673d13dbb7436$var$set = function set(it, metadata) {
        if ($365673d13dbb7436$var$wmhas($365673d13dbb7436$var$store, it)) throw new $365673d13dbb7436$var$TypeError($365673d13dbb7436$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $365673d13dbb7436$var$wmset($365673d13dbb7436$var$store, it, metadata);
        return metadata;
    };
    $365673d13dbb7436$var$get = function get(it) {
        return $365673d13dbb7436$var$wmget($365673d13dbb7436$var$store, it) || {};
    };
    $365673d13dbb7436$var$has = function has(it) {
        return $365673d13dbb7436$var$wmhas($365673d13dbb7436$var$store, it);
    };
} else {
    var $365673d13dbb7436$var$STATE = $9edb78de2fa57a5b$exports("state");
    $406d251f3e123e25$exports[$365673d13dbb7436$var$STATE] = true;
    $365673d13dbb7436$var$set = function set(it, metadata) {
        if ($f886a2c1b39b3cb3$exports(it, $365673d13dbb7436$var$STATE)) throw new $365673d13dbb7436$var$TypeError($365673d13dbb7436$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $289275360326f1a2$exports(it, $365673d13dbb7436$var$STATE, metadata);
        return metadata;
    };
    $365673d13dbb7436$var$get = function get(it) {
        return $f886a2c1b39b3cb3$exports(it, $365673d13dbb7436$var$STATE) ? it[$365673d13dbb7436$var$STATE] : {};
    };
    $365673d13dbb7436$var$has = function has(it) {
        return $f886a2c1b39b3cb3$exports(it, $365673d13dbb7436$var$STATE);
    };
}
$365673d13dbb7436$exports = {
    set: $365673d13dbb7436$var$set,
    get: $365673d13dbb7436$var$get,
    has: $365673d13dbb7436$var$has,
    enforce: $365673d13dbb7436$var$enforce,
    getterFor: $365673d13dbb7436$var$getterFor
};


var $3e3904406a01ba50$exports = {};
"use strict";
var $ca7e2546bb28a324$exports = {};


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $5940e2941ae48cb3$export$2d1720544b23b823;


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $293b53610732ccf4$export$2d1720544b23b823;
"use strict";
var $293b53610732ccf4$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $293b53610732ccf4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $293b53610732ccf4$var$NASHORN_BUG = $293b53610732ccf4$var$getOwnPropertyDescriptor && !$293b53610732ccf4$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$293b53610732ccf4$export$2d1720544b23b823 = $293b53610732ccf4$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $293b53610732ccf4$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $293b53610732ccf4$var$$propertyIsEnumerable;







// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5940e2941ae48cb3$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$5940e2941ae48cb3$export$2d1720544b23b823 = $20523523a5693ba2$exports ? $5940e2941ae48cb3$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $9509281219407356$exports(O);
    P = $0ae3eac2c7ae6b04$exports(P);
    if ($fe4ab78356ccf25d$exports) try {
        return $5940e2941ae48cb3$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($f886a2c1b39b3cb3$exports(O, P)) return $fab109c800ab897b$exports(!$aac63ddfd5f198a9$exports($293b53610732ccf4$export$2d1720544b23b823, O, P), O[P]);
};


var $ca7e2546bb28a324$require$getOwnPropertyDescriptor = $5940e2941ae48cb3$export$2d1720544b23b823;

var $f148dd7e55499544$exports = {};







var $dbda3f159bdaebfe$exports = {};


var $dbda3f159bdaebfe$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dbda3f159bdaebfe$var$getDescriptor = $20523523a5693ba2$exports && Object.getOwnPropertyDescriptor;
var $dbda3f159bdaebfe$var$EXISTS = $f886a2c1b39b3cb3$exports($dbda3f159bdaebfe$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $dbda3f159bdaebfe$var$PROPER = $dbda3f159bdaebfe$var$EXISTS && (function something() {}).name === "something";
var $dbda3f159bdaebfe$var$CONFIGURABLE = $dbda3f159bdaebfe$var$EXISTS && (!$20523523a5693ba2$exports || $20523523a5693ba2$exports && $dbda3f159bdaebfe$var$getDescriptor($dbda3f159bdaebfe$var$FunctionPrototype, "name").configurable);
$dbda3f159bdaebfe$exports = {
    EXISTS: $dbda3f159bdaebfe$var$EXISTS,
    PROPER: $dbda3f159bdaebfe$var$PROPER,
    CONFIGURABLE: $dbda3f159bdaebfe$var$CONFIGURABLE
};


var $f148dd7e55499544$require$CONFIGURABLE_FUNCTION_NAME = $dbda3f159bdaebfe$exports.CONFIGURABLE;
var $f148dd7e55499544$var$getInternalState = $365673d13dbb7436$exports.get;
var $f148dd7e55499544$var$enforceInternalState = $365673d13dbb7436$exports.enforce;
var $f148dd7e55499544$var$TEMPLATE = String(String).split("String");
($f148dd7e55499544$exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var name = options && options.name !== undefined ? options.name : key;
    var state;
    if ($0f655c465e686369$exports(value)) {
        if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
        if (!$f886a2c1b39b3cb3$exports(value, "name") || $f148dd7e55499544$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) $289275360326f1a2$exports(value, "name", name);
        state = $f148dd7e55499544$var$enforceInternalState(value);
        if (!state.source) state.source = $f148dd7e55499544$var$TEMPLATE.join(typeof name == "string" ? name : "");
    }
    if (O === $9785bc7eee705f57$exports) {
        if (simple) O[key] = value;
        else $7f3ab6b2787fa7d1$exports(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $289275360326f1a2$exports(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return $0f655c465e686369$exports(this) && $f148dd7e55499544$var$getInternalState(this).source || $927f93300a754aec$exports(this);
});



var $71d978e608716e12$exports = {};

var $1f63d5515e77eb4b$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $fc39b5778ac5e011$export$2d1720544b23b823;


var $fc39b5778ac5e011$var$hiddenKeys = $0cb6c18da4640278$exports.concat("length", "prototype");
$fc39b5778ac5e011$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $bfd6868c7ce43922$exports(O, $fc39b5778ac5e011$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $133d5ce3b00f9f4b$export$2d1720544b23b823;
$133d5ce3b00f9f4b$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $1f63d5515e77eb4b$var$concat = $e96b4307caf506f9$exports([].concat);
// all object keys, includes non-enumerable and symbols
$1f63d5515e77eb4b$exports = $6a795625cd8d5ee1$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $fc39b5778ac5e011$export$2d1720544b23b823($26044fb63f4c2e37$exports(it));
    var getOwnPropertySymbols = $133d5ce3b00f9f4b$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $1f63d5515e77eb4b$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$71d978e608716e12$exports = function(target, source) {
    var keys = $1f63d5515e77eb4b$exports(source);
    var defineProperty = $20cd9102a9945d8c$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $5940e2941ae48cb3$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$f886a2c1b39b3cb3$exports(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $30b2a7a4e6c463e4$exports = {};


var $30b2a7a4e6c463e4$var$replacement = /#|\.prototype\./;
var $30b2a7a4e6c463e4$var$isForced = function isForced(feature, detection) {
    var value = $30b2a7a4e6c463e4$var$data[$30b2a7a4e6c463e4$var$normalize(feature)];
    return value == $30b2a7a4e6c463e4$var$POLYFILL ? true : value == $30b2a7a4e6c463e4$var$NATIVE ? false : $0f655c465e686369$exports(detection) ? $38b87967b8795bbc$exports(detection) : !!detection;
};
var $30b2a7a4e6c463e4$var$normalize = $30b2a7a4e6c463e4$var$isForced.normalize = function normalize(string) {
    return String(string).replace($30b2a7a4e6c463e4$var$replacement, ".").toLowerCase();
};
var $30b2a7a4e6c463e4$var$data = $30b2a7a4e6c463e4$var$isForced.data = {};
var $30b2a7a4e6c463e4$var$NATIVE = $30b2a7a4e6c463e4$var$isForced.NATIVE = "N";
var $30b2a7a4e6c463e4$var$POLYFILL = $30b2a7a4e6c463e4$var$isForced.POLYFILL = "P";
$30b2a7a4e6c463e4$exports = $30b2a7a4e6c463e4$var$isForced;


/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/ $ca7e2546bb28a324$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $9785bc7eee705f57$exports;
    else if (STATIC) target = $9785bc7eee705f57$exports[TARGET] || $7f3ab6b2787fa7d1$exports(TARGET, {});
    else target = ($9785bc7eee705f57$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $ca7e2546bb28a324$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $30b2a7a4e6c463e4$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $f33cb39429247b78$export$5f0017c582d45a2d)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $f33cb39429247b78$export$5f0017c582d45a2d)(targetProperty))) continue;
            $71d978e608716e12$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $289275360326f1a2$exports(sourceProperty, "sham", true);
        // extend global
        $f148dd7e55499544$exports(target, key, sourceProperty, options);
    }
};






var $b0914cb110bf41ba$exports = {};
"use strict";
var $2ed7496ac41240c5$exports = {};
"use strict";



var $2c18d17288896b70$exports = {};





var $f51fc010d67fff03$exports = {};

$f51fc010d67fff03$exports = !$38b87967b8795bbc$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $2c18d17288896b70$var$IE_PROTO = $9edb78de2fa57a5b$exports("IE_PROTO");
var $2c18d17288896b70$var$Object = $9785bc7eee705f57$exports.Object;
var $2c18d17288896b70$var$ObjectPrototype = $2c18d17288896b70$var$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$2c18d17288896b70$exports = $f51fc010d67fff03$exports ? $2c18d17288896b70$var$Object.getPrototypeOf : function(O) {
    var object = $a6a78d3ed911f53c$exports(O);
    if ($f886a2c1b39b3cb3$exports(object, $2c18d17288896b70$var$IE_PROTO)) return object[$2c18d17288896b70$var$IE_PROTO];
    var constructor = object.constructor;
    if ($0f655c465e686369$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $2c18d17288896b70$var$Object ? $2c18d17288896b70$var$ObjectPrototype : null;
};





var $2ed7496ac41240c5$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
var $2ed7496ac41240c5$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $2ed7496ac41240c5$var$IteratorPrototype, $2ed7496ac41240c5$var$PrototypeOfArrayIteratorPrototype, $2ed7496ac41240c5$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $2ed7496ac41240c5$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $2ed7496ac41240c5$var$arrayIterator)) $2ed7496ac41240c5$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $2ed7496ac41240c5$var$PrototypeOfArrayIteratorPrototype = $2c18d17288896b70$exports($2c18d17288896b70$exports($2ed7496ac41240c5$var$arrayIterator));
        if ($2ed7496ac41240c5$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $2ed7496ac41240c5$var$IteratorPrototype = $2ed7496ac41240c5$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $2ed7496ac41240c5$var$NEW_ITERATOR_PROTOTYPE = $2ed7496ac41240c5$var$IteratorPrototype == undefined || $38b87967b8795bbc$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $2ed7496ac41240c5$var$IteratorPrototype[$2ed7496ac41240c5$var$ITERATOR].call(test) !== test;
});
if ($2ed7496ac41240c5$var$NEW_ITERATOR_PROTOTYPE) $2ed7496ac41240c5$var$IteratorPrototype = {};
else if ($f68ec07cf86795a8$exports) $2ed7496ac41240c5$var$IteratorPrototype = $aed245c788e3388d$exports($2ed7496ac41240c5$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$0f655c465e686369$exports($2ed7496ac41240c5$var$IteratorPrototype[$2ed7496ac41240c5$var$ITERATOR])) $f148dd7e55499544$exports($2ed7496ac41240c5$var$IteratorPrototype, $2ed7496ac41240c5$var$ITERATOR, function() {
    return this;
});
$2ed7496ac41240c5$exports = {
    IteratorPrototype: $2ed7496ac41240c5$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $2ed7496ac41240c5$var$BUGGY_SAFARI_ITERATORS
};


var $b0914cb110bf41ba$require$IteratorPrototype = $2ed7496ac41240c5$exports.IteratorPrototype;


var $04a3155e98ce866f$exports = {};

var $04a3155e98ce866f$require$defineProperty = $20cd9102a9945d8c$export$2d1720544b23b823;


var $04a3155e98ce866f$var$TO_STRING_TAG = $e2a74cbbd6f86b5b$exports("toStringTag");
$04a3155e98ce866f$exports = function(it, TAG, STATIC) {
    if (it && !$f886a2c1b39b3cb3$exports(it = STATIC ? it : it.prototype, $04a3155e98ce866f$var$TO_STRING_TAG)) $04a3155e98ce866f$require$defineProperty(it, $04a3155e98ce866f$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $b0914cb110bf41ba$var$returnThis = function returnThis() {
    return this;
};
$b0914cb110bf41ba$exports = function(IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $aed245c788e3388d$exports($b0914cb110bf41ba$require$IteratorPrototype, {
        next: $fab109c800ab897b$exports(1, next)
    });
    $04a3155e98ce866f$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $f7225a60e3548728$exports[TO_STRING_TAG] = $b0914cb110bf41ba$var$returnThis;
    return IteratorConstructor;
};



var $2a1997491052212d$exports = {};
/* eslint-disable no-proto -- safe */ 

var $1d9fb9ef17826189$exports = {};


var $1d9fb9ef17826189$var$String = $9785bc7eee705f57$exports.String;
var $1d9fb9ef17826189$var$TypeError = $9785bc7eee705f57$exports.TypeError;
$1d9fb9ef17826189$exports = function(argument) {
    if (typeof argument == "object" || $0f655c465e686369$exports(argument)) return argument;
    throw $1d9fb9ef17826189$var$TypeError("Can't set " + $1d9fb9ef17826189$var$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$2a1997491052212d$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = $e96b4307caf506f9$exports(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $26044fb63f4c2e37$exports(O);
        $1d9fb9ef17826189$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $3e3904406a01ba50$var$PROPER_FUNCTION_NAME = $dbda3f159bdaebfe$exports.PROPER;
var $3e3904406a01ba50$var$CONFIGURABLE_FUNCTION_NAME = $dbda3f159bdaebfe$exports.CONFIGURABLE;
var $3e3904406a01ba50$var$IteratorPrototype = $2ed7496ac41240c5$exports.IteratorPrototype;
var $3e3904406a01ba50$var$BUGGY_SAFARI_ITERATORS = $2ed7496ac41240c5$exports.BUGGY_SAFARI_ITERATORS;
var $3e3904406a01ba50$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
var $3e3904406a01ba50$var$KEYS = "keys";
var $3e3904406a01ba50$var$VALUES = "values";
var $3e3904406a01ba50$var$ENTRIES = "entries";
var $3e3904406a01ba50$var$returnThis = function returnThis() {
    return this;
};
$3e3904406a01ba50$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $b0914cb110bf41ba$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$3e3904406a01ba50$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $3e3904406a01ba50$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $3e3904406a01ba50$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $3e3904406a01ba50$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$3e3904406a01ba50$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$3e3904406a01ba50$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $2c18d17288896b70$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$f68ec07cf86795a8$exports && $2c18d17288896b70$exports(CurrentIteratorPrototype) !== $3e3904406a01ba50$var$IteratorPrototype) {
                if ($2a1997491052212d$exports) $2a1997491052212d$exports(CurrentIteratorPrototype, $3e3904406a01ba50$var$IteratorPrototype);
                else if (!$0f655c465e686369$exports(CurrentIteratorPrototype[$3e3904406a01ba50$var$ITERATOR])) $f148dd7e55499544$exports(CurrentIteratorPrototype, $3e3904406a01ba50$var$ITERATOR, $3e3904406a01ba50$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $04a3155e98ce866f$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($f68ec07cf86795a8$exports) $f7225a60e3548728$exports[TO_STRING_TAG] = $3e3904406a01ba50$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($3e3904406a01ba50$var$PROPER_FUNCTION_NAME && DEFAULT == $3e3904406a01ba50$var$VALUES && nativeIterator && nativeIterator.name !== $3e3904406a01ba50$var$VALUES) {
        if (!$f68ec07cf86795a8$exports && $3e3904406a01ba50$var$CONFIGURABLE_FUNCTION_NAME) $289275360326f1a2$exports(IterablePrototype, "name", $3e3904406a01ba50$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $aac63ddfd5f198a9$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($3e3904406a01ba50$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($3e3904406a01ba50$var$KEYS),
            entries: getIterationMethod($3e3904406a01ba50$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($3e3904406a01ba50$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $f148dd7e55499544$exports(IterablePrototype, KEY, methods[KEY]);
        } else $ca7e2546bb28a324$exports({
            target: NAME,
            proto: true,
            forced: $3e3904406a01ba50$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$f68ec07cf86795a8$exports || FORCED) && IterablePrototype[$3e3904406a01ba50$var$ITERATOR] !== defaultIterator) $f148dd7e55499544$exports(IterablePrototype, $3e3904406a01ba50$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $f7225a60e3548728$exports[NAME] = defaultIterator;
    return methods;
};


var $fda6dfb98eaa3934$var$ARRAY_ITERATOR = "Array Iterator";
var $fda6dfb98eaa3934$var$setInternalState = $365673d13dbb7436$exports.set;
var $fda6dfb98eaa3934$var$getInternalState = $365673d13dbb7436$exports.getterFor($fda6dfb98eaa3934$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$fda6dfb98eaa3934$exports = $3e3904406a01ba50$exports(Array, "Array", function(iterated, kind) {
    $fda6dfb98eaa3934$var$setInternalState(this, {
        type: $fda6dfb98eaa3934$var$ARRAY_ITERATOR,
        target: $9509281219407356$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $fda6dfb98eaa3934$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
$f7225a60e3548728$exports.Arguments = $f7225a60e3548728$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$6748bb1d887031b0$exports("keys");
$6748bb1d887031b0$exports("values");
$6748bb1d887031b0$exports("entries");







var $eae9cfd3a574c033$exports = {};



var $eae9cfd3a574c033$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
$eae9cfd3a574c033$exports = !$38b87967b8795bbc$exports(function() {
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var searchParams = url.searchParams;
    var result = "";
    url.pathname = "c%20d";
    searchParams.forEach(function(value, key) {
        searchParams["delete"]("b");
        result += key + value;
    });
    return $f68ec07cf86795a8$exports && !url.toJSON || !searchParams.sort || url.href !== "http://a/c%20d?a=1&c=3" || searchParams.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !searchParams[$eae9cfd3a574c033$var$ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});



var $f5215512a9922933$exports = {};

$f5215512a9922933$exports = function(target, src, options) {
    for(var key in src)$f148dd7e55499544$exports(target, key, src[key], options);
    return target;
};





var $e39fe418a5804d3d$exports = {};


var $e39fe418a5804d3d$var$TypeError = $9785bc7eee705f57$exports.TypeError;
$e39fe418a5804d3d$exports = function(it, Prototype) {
    if ($41450826f1ceeca0$exports(Prototype, it)) return it;
    throw $e39fe418a5804d3d$var$TypeError("Incorrect invocation");
};




var $bb7f2fab244cc9f4$exports = {};


var $bb7f2fab244cc9f4$var$bind = $e96b4307caf506f9$exports($e96b4307caf506f9$exports.bind);
// optional / simple context binding
$bb7f2fab244cc9f4$exports = function(fn, that) {
    $d1496995914f9bc8$exports(fn);
    return that === undefined ? fn : $bb7f2fab244cc9f4$var$bind ? $bb7f2fab244cc9f4$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};


var $33c5848fdf716a71$exports = {};

var $fd9da006e2d51809$exports = {};

var $fd9da006e2d51809$var$TO_STRING_TAG = $e2a74cbbd6f86b5b$exports("toStringTag");
var $fd9da006e2d51809$var$test = {};
$fd9da006e2d51809$var$test[$fd9da006e2d51809$var$TO_STRING_TAG] = "z";
$fd9da006e2d51809$exports = String($fd9da006e2d51809$var$test) === "[object z]";





var $33c5848fdf716a71$var$TO_STRING_TAG = $e2a74cbbd6f86b5b$exports("toStringTag");
var $33c5848fdf716a71$var$Object = $9785bc7eee705f57$exports.Object;
// ES3 wrong here
var $33c5848fdf716a71$var$CORRECT_ARGUMENTS = $cff35349a081683c$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $33c5848fdf716a71$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$33c5848fdf716a71$exports = $fd9da006e2d51809$exports ? $cff35349a081683c$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $33c5848fdf716a71$var$tryGet(O = $33c5848fdf716a71$var$Object(it), $33c5848fdf716a71$var$TO_STRING_TAG)) == "string" ? tag : $33c5848fdf716a71$var$CORRECT_ARGUMENTS ? $cff35349a081683c$exports(O) : (result = $cff35349a081683c$exports(O)) == "Object" && $0f655c465e686369$exports(O.callee) ? "Arguments" : result;
};




var $51d8b5b522168b52$exports = {};


var $51d8b5b522168b52$var$String = $9785bc7eee705f57$exports.String;
$51d8b5b522168b52$exports = function(argument) {
    if ($33c5848fdf716a71$exports(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $51d8b5b522168b52$var$String(argument);
};




var $fa87f3ad43685fe5$exports = {};





var $4f05819afeda6800$exports = {};




var $4f05819afeda6800$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
$4f05819afeda6800$exports = function(it) {
    if (it != undefined) return $5e81212a58ed98da$exports(it, $4f05819afeda6800$var$ITERATOR) || $5e81212a58ed98da$exports(it, "@@iterator") || $f7225a60e3548728$exports[$33c5848fdf716a71$exports(it)];
};


var $fa87f3ad43685fe5$var$TypeError = $9785bc7eee705f57$exports.TypeError;
$fa87f3ad43685fe5$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $4f05819afeda6800$exports(argument) : usingIterator;
    if ($d1496995914f9bc8$exports(iteratorMethod)) return $26044fb63f4c2e37$exports($aac63ddfd5f198a9$exports(iteratorMethod, argument));
    throw $fa87f3ad43685fe5$var$TypeError($4dbad185c1fa7cd5$exports(argument) + " is not iterable");
};




var $b6b8b3124479c2f1$exports = {};
var $b0517415a927cb81$exports = {};

$b0517415a927cb81$exports = $e96b4307caf506f9$exports([].slice);


var $b6b8b3124479c2f1$var$floor = Math.floor;
var $b6b8b3124479c2f1$var$mergeSort = function mergeSort1(array, comparefn) {
    var length = array.length;
    var middle = $b6b8b3124479c2f1$var$floor(length / 2);
    return length < 8 ? $b6b8b3124479c2f1$var$insertionSort(array, comparefn) : $b6b8b3124479c2f1$var$merge(array, $b6b8b3124479c2f1$var$mergeSort($b0517415a927cb81$exports(array, 0, middle), comparefn), $b6b8b3124479c2f1$var$mergeSort($b0517415a927cb81$exports(array, middle), comparefn), comparefn);
};
var $b6b8b3124479c2f1$var$insertionSort = function insertionSort(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $b6b8b3124479c2f1$var$merge = function merge(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
$b6b8b3124479c2f1$exports = $b6b8b3124479c2f1$var$mergeSort;


var $6848962f6bdacda0$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
var $6848962f6bdacda0$var$URL_SEARCH_PARAMS = "URLSearchParams";
var $6848962f6bdacda0$var$URL_SEARCH_PARAMS_ITERATOR = $6848962f6bdacda0$var$URL_SEARCH_PARAMS + "Iterator";
var $6848962f6bdacda0$var$setInternalState = $365673d13dbb7436$exports.set;
var $6848962f6bdacda0$var$getInternalParamsState = $365673d13dbb7436$exports.getterFor($6848962f6bdacda0$var$URL_SEARCH_PARAMS);
var $6848962f6bdacda0$var$getInternalIteratorState = $365673d13dbb7436$exports.getterFor($6848962f6bdacda0$var$URL_SEARCH_PARAMS_ITERATOR);
var $6848962f6bdacda0$var$n$Fetch = $6a795625cd8d5ee1$exports("fetch");
var $6848962f6bdacda0$var$N$Request = $6a795625cd8d5ee1$exports("Request");
var $6848962f6bdacda0$var$Headers = $6a795625cd8d5ee1$exports("Headers");
var $6848962f6bdacda0$var$RequestPrototype = $6848962f6bdacda0$var$N$Request && $6848962f6bdacda0$var$N$Request.prototype;
var $6848962f6bdacda0$var$HeadersPrototype = $6848962f6bdacda0$var$Headers && $6848962f6bdacda0$var$Headers.prototype;
var $6848962f6bdacda0$var$RegExp = $9785bc7eee705f57$exports.RegExp;
var $6848962f6bdacda0$var$TypeError = $9785bc7eee705f57$exports.TypeError;
var $6848962f6bdacda0$var$decodeURIComponent = $9785bc7eee705f57$exports.decodeURIComponent;
var $6848962f6bdacda0$var$encodeURIComponent = $9785bc7eee705f57$exports.encodeURIComponent;
var $6848962f6bdacda0$var$charAt = $e96b4307caf506f9$exports("".charAt);
var $6848962f6bdacda0$var$join = $e96b4307caf506f9$exports([].join);
var $6848962f6bdacda0$var$push = $e96b4307caf506f9$exports([].push);
var $6848962f6bdacda0$var$replace = $e96b4307caf506f9$exports("".replace);
var $6848962f6bdacda0$var$shift = $e96b4307caf506f9$exports([].shift);
var $6848962f6bdacda0$var$splice = $e96b4307caf506f9$exports([].splice);
var $6848962f6bdacda0$var$split = $e96b4307caf506f9$exports("".split);
var $6848962f6bdacda0$var$stringSlice = $e96b4307caf506f9$exports("".slice);
var $6848962f6bdacda0$var$plus = /\+/g;
var $6848962f6bdacda0$var$sequences = Array(4);
var $6848962f6bdacda0$var$percentSequence = function percentSequence(bytes) {
    return $6848962f6bdacda0$var$sequences[bytes - 1] || ($6848962f6bdacda0$var$sequences[bytes - 1] = $6848962f6bdacda0$var$RegExp("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var $6848962f6bdacda0$var$percentDecode = function percentDecode(sequence) {
    try {
        return $6848962f6bdacda0$var$decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var $6848962f6bdacda0$var$deserialize = function deserialize(it) {
    var result = $6848962f6bdacda0$var$replace(it, $6848962f6bdacda0$var$plus, " ");
    var bytes = 4;
    try {
        return $6848962f6bdacda0$var$decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = $6848962f6bdacda0$var$replace(result, $6848962f6bdacda0$var$percentSequence(bytes--), $6848962f6bdacda0$var$percentDecode);
        return result;
    }
};
var $6848962f6bdacda0$var$find = /[!'()~]|%20/g;
var $6848962f6bdacda0$var$replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var $6848962f6bdacda0$var$replacer = function replacer(match) {
    return $6848962f6bdacda0$var$replacements[match];
};
var $6848962f6bdacda0$var$serialize = function serialize(it) {
    return $6848962f6bdacda0$var$replace($6848962f6bdacda0$var$encodeURIComponent(it), $6848962f6bdacda0$var$find, $6848962f6bdacda0$var$replacer);
};
var $6848962f6bdacda0$var$parseSearchParams = function parseSearchParams(result, query) {
    if (query) {
        var attributes = $6848962f6bdacda0$var$split(query, "&");
        var index = 0;
        var attribute, entry;
        while(index < attributes.length){
            attribute = attributes[index++];
            if (attribute.length) {
                entry = $6848962f6bdacda0$var$split(attribute, "=");
                $6848962f6bdacda0$var$push(result, {
                    key: $6848962f6bdacda0$var$deserialize($6848962f6bdacda0$var$shift(entry)),
                    value: $6848962f6bdacda0$var$deserialize($6848962f6bdacda0$var$join(entry, "="))
                });
            }
        }
    }
};
var $6848962f6bdacda0$var$updateSearchParams = function updateSearchParams(query) {
    this.entries.length = 0;
    $6848962f6bdacda0$var$parseSearchParams(this.entries, query);
};
var $6848962f6bdacda0$var$validateArgumentsLength = function validateArgumentsLength(passed, required) {
    if (passed < required) throw $6848962f6bdacda0$var$TypeError("Not enough arguments");
};
var $6848962f6bdacda0$var$URLSearchParamsIterator = $b0914cb110bf41ba$exports(function Iterator(params, kind) {
    $6848962f6bdacda0$var$setInternalState(this, {
        type: $6848962f6bdacda0$var$URL_SEARCH_PARAMS_ITERATOR,
        iterator: $fa87f3ad43685fe5$exports($6848962f6bdacda0$var$getInternalParamsState(params).entries),
        kind: kind
    });
}, "Iterator", function next() {
    var state = $6848962f6bdacda0$var$getInternalIteratorState(this);
    var kind = state.kind;
    var step = state.iterator.next();
    var entry = step.value;
    if (!step.done) step.value = kind === "keys" ? entry.key : kind === "values" ? entry.value : [
        entry.key,
        entry.value
    ];
    return step;
});
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $6848962f6bdacda0$var$URLSearchParamsConstructor = function URLSearchParams() {
    $e39fe418a5804d3d$exports(this, $6848962f6bdacda0$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var that = this;
    var entries = [];
    var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;
    $6848962f6bdacda0$var$setInternalState(that, {
        type: $6848962f6bdacda0$var$URL_SEARCH_PARAMS,
        entries: entries,
        updateURL: function updateURL() {},
        updateSearchParams: $6848962f6bdacda0$var$updateSearchParams
    });
    if (init !== undefined) {
        if ($8cb6fbe8e2a19881$exports(init)) {
            iteratorMethod = $4f05819afeda6800$exports(init);
            if (iteratorMethod) {
                iterator = $fa87f3ad43685fe5$exports(init, iteratorMethod);
                next = iterator.next;
                while(!(step = $aac63ddfd5f198a9$exports(next, iterator)).done){
                    entryIterator = $fa87f3ad43685fe5$exports($26044fb63f4c2e37$exports(step.value));
                    entryNext = entryIterator.next;
                    if ((first = $aac63ddfd5f198a9$exports(entryNext, entryIterator)).done || (second = $aac63ddfd5f198a9$exports(entryNext, entryIterator)).done || !$aac63ddfd5f198a9$exports(entryNext, entryIterator).done) throw $6848962f6bdacda0$var$TypeError("Expected sequence with length 2");
                    $6848962f6bdacda0$var$push(entries, {
                        key: $51d8b5b522168b52$exports(first.value),
                        value: $51d8b5b522168b52$exports(second.value)
                    });
                }
            } else for(key in init)if ($f886a2c1b39b3cb3$exports(init, key)) $6848962f6bdacda0$var$push(entries, {
                key: key,
                value: $51d8b5b522168b52$exports(init[key])
            });
        } else $6848962f6bdacda0$var$parseSearchParams(entries, typeof init == "string" ? $6848962f6bdacda0$var$charAt(init, 0) === "?" ? $6848962f6bdacda0$var$stringSlice(init, 1) : init : $51d8b5b522168b52$exports(init));
    }
};
var $6848962f6bdacda0$var$URLSearchParamsPrototype = $6848962f6bdacda0$var$URLSearchParamsConstructor.prototype;
$f5215512a9922933$exports($6848962f6bdacda0$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        $6848962f6bdacda0$var$validateArgumentsLength(arguments.length, 2);
        var state = $6848962f6bdacda0$var$getInternalParamsState(this);
        $6848962f6bdacda0$var$push(state.entries, {
            key: $51d8b5b522168b52$exports(name),
            value: $51d8b5b522168b52$exports(value)
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name) {
        $6848962f6bdacda0$var$validateArgumentsLength(arguments.length, 1);
        var state = $6848962f6bdacda0$var$getInternalParamsState(this);
        var entries = state.entries;
        var key = $51d8b5b522168b52$exports(name);
        var index = 0;
        while(index < entries.length)if (entries[index].key === key) $6848962f6bdacda0$var$splice(entries, index, 1);
        else index++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        $6848962f6bdacda0$var$validateArgumentsLength(arguments.length, 1);
        var entries = $6848962f6bdacda0$var$getInternalParamsState(this).entries;
        var key = $51d8b5b522168b52$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        $6848962f6bdacda0$var$validateArgumentsLength(arguments.length, 1);
        var entries = $6848962f6bdacda0$var$getInternalParamsState(this).entries;
        var key = $51d8b5b522168b52$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $6848962f6bdacda0$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name) {
        $6848962f6bdacda0$var$validateArgumentsLength(arguments.length, 1);
        var entries = $6848962f6bdacda0$var$getInternalParamsState(this).entries;
        var key = $51d8b5b522168b52$exports(name);
        var index = 0;
        while(index < entries.length){
            if (entries[index++].key === key) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        $6848962f6bdacda0$var$validateArgumentsLength(arguments.length, 1);
        var state = $6848962f6bdacda0$var$getInternalParamsState(this);
        var entries = state.entries;
        var found = false;
        var key = $51d8b5b522168b52$exports(name);
        var val = $51d8b5b522168b52$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $6848962f6bdacda0$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $6848962f6bdacda0$var$push(entries, {
            key: key,
            value: val
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $6848962f6bdacda0$var$getInternalParamsState(this);
        $b6b8b3124479c2f1$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $6848962f6bdacda0$var$getInternalParamsState(this).entries;
        var boundFunction = $bb7f2fab244cc9f4$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $6848962f6bdacda0$var$URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $6848962f6bdacda0$var$URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $6848962f6bdacda0$var$URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$f148dd7e55499544$exports($6848962f6bdacda0$var$URLSearchParamsPrototype, $6848962f6bdacda0$var$ITERATOR, $6848962f6bdacda0$var$URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$f148dd7e55499544$exports($6848962f6bdacda0$var$URLSearchParamsPrototype, "toString", function toString() {
    var entries = $6848962f6bdacda0$var$getInternalParamsState(this).entries;
    var result = [];
    var index = 0;
    var entry;
    while(index < entries.length){
        entry = entries[index++];
        $6848962f6bdacda0$var$push(result, $6848962f6bdacda0$var$serialize(entry.key) + "=" + $6848962f6bdacda0$var$serialize(entry.value));
    }
    return $6848962f6bdacda0$var$join(result, "&");
}, {
    enumerable: true
});
$04a3155e98ce866f$exports($6848962f6bdacda0$var$URLSearchParamsConstructor, $6848962f6bdacda0$var$URL_SEARCH_PARAMS);
$ca7e2546bb28a324$exports({
    global: true,
    forced: !$eae9cfd3a574c033$exports
}, {
    URLSearchParams: $6848962f6bdacda0$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$eae9cfd3a574c033$exports && $0f655c465e686369$exports($6848962f6bdacda0$var$Headers)) {
    var $6848962f6bdacda0$var$headersHas = $e96b4307caf506f9$exports($6848962f6bdacda0$var$HeadersPrototype.has);
    var $6848962f6bdacda0$var$headersSet = $e96b4307caf506f9$exports($6848962f6bdacda0$var$HeadersPrototype.set);
    var $6848962f6bdacda0$var$wrapRequestOptions = function wrapRequestOptions(init) {
        if ($8cb6fbe8e2a19881$exports(init)) {
            var body = init.body;
            var headers;
            if ($33c5848fdf716a71$exports(body) === $6848962f6bdacda0$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $6848962f6bdacda0$var$Headers(init.headers) : new $6848962f6bdacda0$var$Headers();
                if (!$6848962f6bdacda0$var$headersHas(headers, "content-type")) $6848962f6bdacda0$var$headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return $aed245c788e3388d$exports(init, {
                    body: $fab109c800ab897b$exports(0, $51d8b5b522168b52$exports(body)),
                    headers: $fab109c800ab897b$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($0f655c465e686369$exports($6848962f6bdacda0$var$n$Fetch)) $ca7e2546bb28a324$exports({
        global: true,
        enumerable: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $6848962f6bdacda0$var$n$Fetch(input, arguments.length > 1 ? $6848962f6bdacda0$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($0f655c465e686369$exports($6848962f6bdacda0$var$N$Request)) {
        var $6848962f6bdacda0$var$RequestConstructor = function Request(input /* , init */ ) {
            $e39fe418a5804d3d$exports(this, $6848962f6bdacda0$var$RequestPrototype);
            return new $6848962f6bdacda0$var$N$Request(input, arguments.length > 1 ? $6848962f6bdacda0$var$wrapRequestOptions(arguments[1]) : {});
        };
        $6848962f6bdacda0$var$RequestPrototype.constructor = $6848962f6bdacda0$var$RequestConstructor;
        $6848962f6bdacda0$var$RequestConstructor.prototype = $6848962f6bdacda0$var$RequestPrototype;
        $ca7e2546bb28a324$exports({
            global: true,
            forced: true
        }, {
            Request: $6848962f6bdacda0$var$RequestConstructor
        });
    }
}
$6848962f6bdacda0$exports = {
    URLSearchParams: $6848962f6bdacda0$var$URLSearchParamsConstructor,
    getState: $6848962f6bdacda0$var$getInternalParamsState
};


var $2a825a53c6152885$exports = {};

$2a825a53c6152885$exports = $9785bc7eee705f57$exports;


$744bc9442daea4b8$exports = $2a825a53c6152885$exports.URLSearchParams;



var $6cea8b5cc29e6bf3$exports = {};
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$6cea8b5cc29e6bf3$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $1f70da37cbc8d93b$exports = {};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`

var $1f70da37cbc8d93b$var$classList = $487e3947e385675d$exports("span").classList;
var $1f70da37cbc8d93b$var$DOMTokenListPrototype = $1f70da37cbc8d93b$var$classList && $1f70da37cbc8d93b$var$classList.constructor && $1f70da37cbc8d93b$var$classList.constructor.prototype;
$1f70da37cbc8d93b$exports = $1f70da37cbc8d93b$var$DOMTokenListPrototype === Object.prototype ? undefined : $1f70da37cbc8d93b$var$DOMTokenListPrototype;





var $4e36fbc59b6953cc$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
var $4e36fbc59b6953cc$var$TO_STRING_TAG = $e2a74cbbd6f86b5b$exports("toStringTag");
var $4e36fbc59b6953cc$var$ArrayValues = $fda6dfb98eaa3934$exports.values;
var $4e36fbc59b6953cc$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$4e36fbc59b6953cc$var$ITERATOR] !== $4e36fbc59b6953cc$var$ArrayValues) try {
            $289275360326f1a2$exports(CollectionPrototype, $4e36fbc59b6953cc$var$ITERATOR, $4e36fbc59b6953cc$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$4e36fbc59b6953cc$var$ITERATOR] = $4e36fbc59b6953cc$var$ArrayValues;
        }
        if (!CollectionPrototype[$4e36fbc59b6953cc$var$TO_STRING_TAG]) $289275360326f1a2$exports(CollectionPrototype, $4e36fbc59b6953cc$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($6cea8b5cc29e6bf3$exports[COLLECTION_NAME]) for(var METHOD_NAME in $fda6dfb98eaa3934$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $fda6dfb98eaa3934$exports[METHOD_NAME]) try {
                $289275360326f1a2$exports(CollectionPrototype, METHOD_NAME, $fda6dfb98eaa3934$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $fda6dfb98eaa3934$exports[METHOD_NAME];
            }
        }
    }
};
for(var $4e36fbc59b6953cc$var$COLLECTION_NAME in $6cea8b5cc29e6bf3$exports)$4e36fbc59b6953cc$var$handlePrototype($9785bc7eee705f57$exports[$4e36fbc59b6953cc$var$COLLECTION_NAME] && $9785bc7eee705f57$exports[$4e36fbc59b6953cc$var$COLLECTION_NAME].prototype, $4e36fbc59b6953cc$var$COLLECTION_NAME);
$4e36fbc59b6953cc$var$handlePrototype($1f70da37cbc8d93b$exports, "DOMTokenList");


$20677542c7d32647$exports = $744bc9442daea4b8$exports;


$cc41b945fd7849be$exports = $20677542c7d32647$exports;


var $8b2b7f58bf0f3834$exports = {};
var $e0723339388ba3db$exports = {};
var $55b59fa101c837af$exports = {};
"use strict";
"use strict";
var $4294e4303e112634$exports = {};




var $4294e4303e112634$var$charAt = $e96b4307caf506f9$exports("".charAt);
var $4294e4303e112634$var$charCodeAt = $e96b4307caf506f9$exports("".charCodeAt);
var $4294e4303e112634$var$stringSlice = $e96b4307caf506f9$exports("".slice);
var $4294e4303e112634$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $51d8b5b522168b52$exports($ad5205f5712371b7$exports($this));
        var position = $d7929eea7f09ee32$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $4294e4303e112634$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $4294e4303e112634$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $4294e4303e112634$var$charAt(S, position) : first : CONVERT_TO_STRING ? $4294e4303e112634$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$4294e4303e112634$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $4294e4303e112634$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $4294e4303e112634$var$createMethod(true)
};


var $78465dcc02bdaad9$require$charAt = $4294e4303e112634$exports.charAt;



var $78465dcc02bdaad9$var$STRING_ITERATOR = "String Iterator";
var $78465dcc02bdaad9$var$setInternalState = $365673d13dbb7436$exports.set;
var $78465dcc02bdaad9$var$getInternalState = $365673d13dbb7436$exports.getterFor($78465dcc02bdaad9$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$3e3904406a01ba50$exports(String, "String", function(iterated) {
    $78465dcc02bdaad9$var$setInternalState(this, {
        type: $78465dcc02bdaad9$var$STRING_ITERATOR,
        string: $51d8b5b522168b52$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $78465dcc02bdaad9$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = $78465dcc02bdaad9$require$charAt(string, index);
    state.index += point.length;
    return {
        value: point,
        done: false
    };
});













var $ae0b41f00875a9fe$exports = {};
"use strict";









// eslint-disable-next-line es/no-object-assign -- safe
var $ae0b41f00875a9fe$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $ae0b41f00875a9fe$var$defineProperty = Object.defineProperty;
var $ae0b41f00875a9fe$var$concat = $e96b4307caf506f9$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$ae0b41f00875a9fe$exports = !$ae0b41f00875a9fe$var$$assign || $38b87967b8795bbc$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($20523523a5693ba2$exports && $ae0b41f00875a9fe$var$$assign({
        b: 1
    }, $ae0b41f00875a9fe$var$$assign($ae0b41f00875a9fe$var$defineProperty({}, "a", {
        enumerable: true,
        get: function get() {
            $ae0b41f00875a9fe$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $ae0b41f00875a9fe$var$$assign({}, A)[symbol] != 7 || $32f837dd54d791a6$exports($ae0b41f00875a9fe$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $a6a78d3ed911f53c$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $133d5ce3b00f9f4b$export$2d1720544b23b823;
    var propertyIsEnumerable = $293b53610732ccf4$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $5bdc3bfa96892a98$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $ae0b41f00875a9fe$var$concat($32f837dd54d791a6$exports(S), getOwnPropertySymbols(S)) : $32f837dd54d791a6$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$20523523a5693ba2$exports || $aac63ddfd5f198a9$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $ae0b41f00875a9fe$var$$assign;


var $0a4fb4e96a13ece2$exports = {};
"use strict";




var $ef46f30de6f33a69$exports = {};

var $263b5fb3867a4de7$exports = {};



$263b5fb3867a4de7$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $26044fb63f4c2e37$exports(iterator);
    try {
        innerResult = $5e81212a58ed98da$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $aac63ddfd5f198a9$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $26044fb63f4c2e37$exports(innerResult);
    return value;
};


// call something on iterator step with safe closing on error
$ef46f30de6f33a69$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($26044fb63f4c2e37$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $263b5fb3867a4de7$exports(iterator, "throw", error);
    }
};


var $6726a114d2f64b83$exports = {};


var $6726a114d2f64b83$var$ITERATOR = $e2a74cbbd6f86b5b$exports("iterator");
var $6726a114d2f64b83$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$6726a114d2f64b83$exports = function(it) {
    return it !== undefined && ($f7225a60e3548728$exports.Array === it || $6726a114d2f64b83$var$ArrayPrototype[$6726a114d2f64b83$var$ITERATOR] === it);
};


var $a1385e558f17751c$exports = {};






var $a1385e558f17751c$var$noop = function noop() {};
var $a1385e558f17751c$var$empty = [];
var $a1385e558f17751c$var$construct = $6a795625cd8d5ee1$exports("Reflect", "construct");
var $a1385e558f17751c$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $a1385e558f17751c$var$exec = $e96b4307caf506f9$exports($a1385e558f17751c$var$constructorRegExp.exec);
var $a1385e558f17751c$var$INCORRECT_TO_STRING = !$a1385e558f17751c$var$constructorRegExp.exec($a1385e558f17751c$var$noop);
var $a1385e558f17751c$var$isConstructorModern = function isConstructorModern(argument) {
    if (!$0f655c465e686369$exports(argument)) return false;
    try {
        $a1385e558f17751c$var$construct($a1385e558f17751c$var$noop, $a1385e558f17751c$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $a1385e558f17751c$var$isConstructorLegacy = function isConstructorLegacy(argument) {
    if (!$0f655c465e686369$exports(argument)) return false;
    switch($33c5848fdf716a71$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    return $a1385e558f17751c$var$INCORRECT_TO_STRING || !!$a1385e558f17751c$var$exec($a1385e558f17751c$var$constructorRegExp, $927f93300a754aec$exports(argument));
};
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$a1385e558f17751c$exports = !$a1385e558f17751c$var$construct || $38b87967b8795bbc$exports(function() {
    var called;
    return $a1385e558f17751c$var$isConstructorModern($a1385e558f17751c$var$isConstructorModern.call) || !$a1385e558f17751c$var$isConstructorModern(Object) || !$a1385e558f17751c$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $a1385e558f17751c$var$isConstructorLegacy : $a1385e558f17751c$var$isConstructorModern;



var $3b1f69d64fef9c80$exports = {};
"use strict";



$3b1f69d64fef9c80$exports = function(object, key, value) {
    var propertyKey = $0ae3eac2c7ae6b04$exports(key);
    if (propertyKey in object) $20cd9102a9945d8c$export$2d1720544b23b823(object, propertyKey, $fab109c800ab897b$exports(0, value));
    else object[propertyKey] = value;
};




var $0a4fb4e96a13ece2$var$Array = $9785bc7eee705f57$exports.Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$0a4fb4e96a13ece2$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $a6a78d3ed911f53c$exports(arrayLike);
    var IS_CONSTRUCTOR = $a1385e558f17751c$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $bb7f2fab244cc9f4$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $4f05819afeda6800$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this == $0a4fb4e96a13ece2$var$Array && $6726a114d2f64b83$exports(iteratorMethod))) {
        iterator = $fa87f3ad43685fe5$exports(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $aac63ddfd5f198a9$exports(next, iterator)).done; index++){
            value = mapping ? $ef46f30de6f33a69$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $3b1f69d64fef9c80$exports(result, index, value);
        }
    } else {
        length = $b94f205d951cc40c$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $0a4fb4e96a13ece2$var$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $3b1f69d64fef9c80$exports(result, index, value);
        }
    }
    result.length = index;
    return result;
};




var $6c0481f2cb568699$require$codeAt = $4294e4303e112634$exports.codeAt;
var $c6f825f6a9717d7c$exports = {};
"use strict";


var $c6f825f6a9717d7c$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $c6f825f6a9717d7c$var$base = 36;
var $c6f825f6a9717d7c$var$tMin = 1;
var $c6f825f6a9717d7c$var$tMax = 26;
var $c6f825f6a9717d7c$var$skew = 38;
var $c6f825f6a9717d7c$var$damp = 700;
var $c6f825f6a9717d7c$var$initialBias = 72;
var $c6f825f6a9717d7c$var$initialN = 128; // 0x80
var $c6f825f6a9717d7c$var$delimiter = "-"; // '\x2D'
var $c6f825f6a9717d7c$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $c6f825f6a9717d7c$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $c6f825f6a9717d7c$var$OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var $c6f825f6a9717d7c$var$baseMinusTMin = $c6f825f6a9717d7c$var$base - $c6f825f6a9717d7c$var$tMin;
var $c6f825f6a9717d7c$var$RangeError = $9785bc7eee705f57$exports.RangeError;
var $c6f825f6a9717d7c$var$exec = $e96b4307caf506f9$exports($c6f825f6a9717d7c$var$regexSeparators.exec);
var $c6f825f6a9717d7c$var$floor = Math.floor;
var $c6f825f6a9717d7c$var$fromCharCode = String.fromCharCode;
var $c6f825f6a9717d7c$var$charCodeAt = $e96b4307caf506f9$exports("".charCodeAt);
var $c6f825f6a9717d7c$var$join = $e96b4307caf506f9$exports([].join);
var $c6f825f6a9717d7c$var$push = $e96b4307caf506f9$exports([].push);
var $c6f825f6a9717d7c$var$replace = $e96b4307caf506f9$exports("".replace);
var $c6f825f6a9717d7c$var$split = $e96b4307caf506f9$exports("".split);
var $c6f825f6a9717d7c$var$toLowerCase = $e96b4307caf506f9$exports("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $c6f825f6a9717d7c$var$ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $c6f825f6a9717d7c$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $c6f825f6a9717d7c$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) == 0xDC00) $c6f825f6a9717d7c$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $c6f825f6a9717d7c$var$push(output, value);
                counter--;
            }
        } else $c6f825f6a9717d7c$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $c6f825f6a9717d7c$var$digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $c6f825f6a9717d7c$var$adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $c6f825f6a9717d7c$var$floor(delta / $c6f825f6a9717d7c$var$damp) : delta >> 1;
    delta += $c6f825f6a9717d7c$var$floor(delta / numPoints);
    for(; delta > $c6f825f6a9717d7c$var$baseMinusTMin * $c6f825f6a9717d7c$var$tMax >> 1; k += $c6f825f6a9717d7c$var$base)delta = $c6f825f6a9717d7c$var$floor(delta / $c6f825f6a9717d7c$var$baseMinusTMin);
    return $c6f825f6a9717d7c$var$floor(k + ($c6f825f6a9717d7c$var$baseMinusTMin + 1) * delta / (delta + $c6f825f6a9717d7c$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ // eslint-disable-next-line max-statements -- TODO
var $c6f825f6a9717d7c$var$encode = function encode(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $c6f825f6a9717d7c$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $c6f825f6a9717d7c$var$initialN;
    var delta = 0;
    var bias = $c6f825f6a9717d7c$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $c6f825f6a9717d7c$var$push(output, $c6f825f6a9717d7c$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $c6f825f6a9717d7c$var$push(output, $c6f825f6a9717d7c$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $c6f825f6a9717d7c$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $c6f825f6a9717d7c$var$floor(($c6f825f6a9717d7c$var$maxInt - delta) / handledCPCountPlusOne)) throw $c6f825f6a9717d7c$var$RangeError($c6f825f6a9717d7c$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $c6f825f6a9717d7c$var$maxInt) throw $c6f825f6a9717d7c$var$RangeError($c6f825f6a9717d7c$var$OVERFLOW_ERROR);
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                for(var k = $c6f825f6a9717d7c$var$base;; k += $c6f825f6a9717d7c$var$base){
                    var t = k <= bias ? $c6f825f6a9717d7c$var$tMin : k >= bias + $c6f825f6a9717d7c$var$tMax ? $c6f825f6a9717d7c$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $c6f825f6a9717d7c$var$base - t;
                    $c6f825f6a9717d7c$var$push(output, $c6f825f6a9717d7c$var$fromCharCode($c6f825f6a9717d7c$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $c6f825f6a9717d7c$var$floor(qMinusT / baseMinusT);
                }
                $c6f825f6a9717d7c$var$push(output, $c6f825f6a9717d7c$var$fromCharCode($c6f825f6a9717d7c$var$digitToBasic(q)));
                bias = $c6f825f6a9717d7c$var$adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return $c6f825f6a9717d7c$var$join(output, "");
};
$c6f825f6a9717d7c$exports = function(input) {
    var encoded = [];
    var labels = $c6f825f6a9717d7c$var$split($c6f825f6a9717d7c$var$replace($c6f825f6a9717d7c$var$toLowerCase(input), $c6f825f6a9717d7c$var$regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $c6f825f6a9717d7c$var$push(encoded, $c6f825f6a9717d7c$var$exec($c6f825f6a9717d7c$var$regexNonASCII, label) ? "xn--" + $c6f825f6a9717d7c$var$encode(label) : label);
    }
    return $c6f825f6a9717d7c$var$join(encoded, ".");
};






var $6c0481f2cb568699$var$setInternalState = $365673d13dbb7436$exports.set;
var $6c0481f2cb568699$var$getInternalURLState = $365673d13dbb7436$exports.getterFor("URL");
var $6c0481f2cb568699$var$URLSearchParams = $6848962f6bdacda0$exports.URLSearchParams;
var $6c0481f2cb568699$var$getInternalSearchParamsState = $6848962f6bdacda0$exports.getState;
var $6c0481f2cb568699$var$NativeURL = $9785bc7eee705f57$exports.URL;
var $6c0481f2cb568699$var$TypeError = $9785bc7eee705f57$exports.TypeError;
var $6c0481f2cb568699$var$parseInt = $9785bc7eee705f57$exports.parseInt;
var $6c0481f2cb568699$var$floor = Math.floor;
var $6c0481f2cb568699$var$pow = Math.pow;
var $6c0481f2cb568699$var$charAt = $e96b4307caf506f9$exports("".charAt);
var $6c0481f2cb568699$var$exec = $e96b4307caf506f9$exports(/./.exec);
var $6c0481f2cb568699$var$join = $e96b4307caf506f9$exports([].join);
var $6c0481f2cb568699$var$numberToString = $e96b4307caf506f9$exports(1.0.toString);
var $6c0481f2cb568699$var$pop = $e96b4307caf506f9$exports([].pop);
var $6c0481f2cb568699$var$push = $e96b4307caf506f9$exports([].push);
var $6c0481f2cb568699$var$replace = $e96b4307caf506f9$exports("".replace);
var $6c0481f2cb568699$var$shift = $e96b4307caf506f9$exports([].shift);
var $6c0481f2cb568699$var$split = $e96b4307caf506f9$exports("".split);
var $6c0481f2cb568699$var$stringSlice = $e96b4307caf506f9$exports("".slice);
var $6c0481f2cb568699$var$toLowerCase = $e96b4307caf506f9$exports("".toLowerCase);
var $6c0481f2cb568699$var$unshift = $e96b4307caf506f9$exports([].unshift);
var $6c0481f2cb568699$var$INVALID_AUTHORITY = "Invalid authority";
var $6c0481f2cb568699$var$INVALID_SCHEME = "Invalid scheme";
var $6c0481f2cb568699$var$INVALID_HOST = "Invalid host";
var $6c0481f2cb568699$var$INVALID_PORT = "Invalid port";
var $6c0481f2cb568699$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $6c0481f2cb568699$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $6c0481f2cb568699$var$DIGIT = /\d/;
var $6c0481f2cb568699$var$HEX_START = /^0x/i;
var $6c0481f2cb568699$var$OCT = /^[0-7]+$/;
var $6c0481f2cb568699$var$DEC = /^\d+$/;
var $6c0481f2cb568699$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $6c0481f2cb568699$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $6c0481f2cb568699$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $6c0481f2cb568699$var$LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var $6c0481f2cb568699$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var $6c0481f2cb568699$var$EOF;
var $6c0481f2cb568699$var$parseHost = function parseHost(url, input) {
    var result, codePoints, index;
    if ($6c0481f2cb568699$var$charAt(input, 0) == "[") {
        if ($6c0481f2cb568699$var$charAt(input, input.length - 1) != "]") return $6c0481f2cb568699$var$INVALID_HOST;
        result = $6c0481f2cb568699$var$parseIPv6($6c0481f2cb568699$var$stringSlice(input, 1, -1));
        if (!result) return $6c0481f2cb568699$var$INVALID_HOST;
        url.host = result;
    // opaque host
    } else if (!$6c0481f2cb568699$var$isSpecial(url)) {
        if ($6c0481f2cb568699$var$exec($6c0481f2cb568699$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $6c0481f2cb568699$var$INVALID_HOST;
        result = "";
        codePoints = $0a4fb4e96a13ece2$exports(input);
        for(index = 0; index < codePoints.length; index++)result += $6c0481f2cb568699$var$percentEncode(codePoints[index], $6c0481f2cb568699$var$C0ControlPercentEncodeSet);
        url.host = result;
    } else {
        input = $c6f825f6a9717d7c$exports(input);
        if ($6c0481f2cb568699$var$exec($6c0481f2cb568699$var$FORBIDDEN_HOST_CODE_POINT, input)) return $6c0481f2cb568699$var$INVALID_HOST;
        result = $6c0481f2cb568699$var$parseIPv4(input);
        if (result === null) return $6c0481f2cb568699$var$INVALID_HOST;
        url.host = result;
    }
};
var $6c0481f2cb568699$var$parseIPv4 = function parseIPv4(input) {
    var parts = $6c0481f2cb568699$var$split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] == "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part == "") return input;
        radix = 10;
        if (part.length > 1 && $6c0481f2cb568699$var$charAt(part, 0) == "0") {
            radix = $6c0481f2cb568699$var$exec($6c0481f2cb568699$var$HEX_START, part) ? 16 : 8;
            part = $6c0481f2cb568699$var$stringSlice(part, radix == 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!$6c0481f2cb568699$var$exec(radix == 10 ? $6c0481f2cb568699$var$DEC : radix == 8 ? $6c0481f2cb568699$var$OCT : $6c0481f2cb568699$var$HEX, part)) return input;
            number = $6c0481f2cb568699$var$parseInt(part, radix);
        }
        $6c0481f2cb568699$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index == partsLength - 1) {
            if (number >= $6c0481f2cb568699$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $6c0481f2cb568699$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $6c0481f2cb568699$var$pow(256, 3 - index);
    return ipv4;
};
// eslint-disable-next-line max-statements -- TODO
var $6c0481f2cb568699$var$parseIPv6 = function parseIPv6(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function chr() {
        return $6c0481f2cb568699$var$charAt(input, pointer);
    };
    if (chr() == ":") {
        if ($6c0481f2cb568699$var$charAt(input, 1) != ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex == 8) return;
        if (chr() == ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $6c0481f2cb568699$var$exec($6c0481f2cb568699$var$HEX, chr())){
            value = value * 16 + $6c0481f2cb568699$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() == ".") {
            if (length == 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() == "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$6c0481f2cb568699$var$exec($6c0481f2cb568699$var$DIGIT, chr())) return;
                while($6c0481f2cb568699$var$exec($6c0481f2cb568699$var$DIGIT, chr())){
                    number = $6c0481f2cb568699$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece == 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
            }
            if (numbersSeen != 4) return;
            break;
        } else if (chr() == ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex != 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex != 8) return;
    return address;
};
var $6c0481f2cb568699$var$findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
var $6c0481f2cb568699$var$serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            $6c0481f2cb568699$var$unshift(result, host % 256);
            host = $6c0481f2cb568699$var$floor(host / 256);
        }
        return $6c0481f2cb568699$var$join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = $6c0481f2cb568699$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += $6c0481f2cb568699$var$numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var $6c0481f2cb568699$var$C0ControlPercentEncodeSet = {};
var $6c0481f2cb568699$var$fragmentPercentEncodeSet = $ae0b41f00875a9fe$exports({}, $6c0481f2cb568699$var$C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var $6c0481f2cb568699$var$pathPercentEncodeSet = $ae0b41f00875a9fe$exports({}, $6c0481f2cb568699$var$fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var $6c0481f2cb568699$var$userinfoPercentEncodeSet = $ae0b41f00875a9fe$exports({}, $6c0481f2cb568699$var$pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var $6c0481f2cb568699$var$percentEncode = function percentEncode(chr, set) {
    var code = $6c0481f2cb568699$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$f886a2c1b39b3cb3$exports(set, chr) ? chr : encodeURIComponent(chr);
};
var $6c0481f2cb568699$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
var $6c0481f2cb568699$var$isSpecial = function isSpecial(url) {
    return $f886a2c1b39b3cb3$exports($6c0481f2cb568699$var$specialSchemes, url.scheme);
};
var $6c0481f2cb568699$var$includesCredentials = function includesCredentials(url) {
    return url.username != "" || url.password != "";
};
var $6c0481f2cb568699$var$cannotHaveUsernamePasswordPort = function cannotHaveUsernamePasswordPort(url) {
    return !url.host || url.cannotBeABaseURL || url.scheme == "file";
};
var $6c0481f2cb568699$var$isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length == 2 && $6c0481f2cb568699$var$exec($6c0481f2cb568699$var$ALPHA, $6c0481f2cb568699$var$charAt(string, 0)) && ((second = $6c0481f2cb568699$var$charAt(string, 1)) == ":" || !normalized && second == "|");
};
var $6c0481f2cb568699$var$startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && $6c0481f2cb568699$var$isWindowsDriveLetter($6c0481f2cb568699$var$stringSlice(string, 0, 2)) && (string.length == 2 || (third = $6c0481f2cb568699$var$charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
var $6c0481f2cb568699$var$shortenURLsPath = function shortenURLsPath(url) {
    var path = url.path;
    var pathSize = path.length;
    if (pathSize && (url.scheme != "file" || pathSize != 1 || !$6c0481f2cb568699$var$isWindowsDriveLetter(path[0], true))) path.length--;
};
var $6c0481f2cb568699$var$isSingleDot = function isSingleDot(segment) {
    return segment === "." || $6c0481f2cb568699$var$toLowerCase(segment) === "%2e";
};
var $6c0481f2cb568699$var$isDoubleDot = function isDoubleDot(segment) {
    segment = $6c0481f2cb568699$var$toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var $6c0481f2cb568699$var$SCHEME_START = {};
var $6c0481f2cb568699$var$SCHEME = {};
var $6c0481f2cb568699$var$NO_SCHEME = {};
var $6c0481f2cb568699$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $6c0481f2cb568699$var$PATH_OR_AUTHORITY = {};
var $6c0481f2cb568699$var$RELATIVE = {};
var $6c0481f2cb568699$var$RELATIVE_SLASH = {};
var $6c0481f2cb568699$var$SPECIAL_AUTHORITY_SLASHES = {};
var $6c0481f2cb568699$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $6c0481f2cb568699$var$AUTHORITY = {};
var $6c0481f2cb568699$var$HOST = {};
var $6c0481f2cb568699$var$HOSTNAME = {};
var $6c0481f2cb568699$var$PORT = {};
var $6c0481f2cb568699$var$FILE = {};
var $6c0481f2cb568699$var$FILE_SLASH = {};
var $6c0481f2cb568699$var$FILE_HOST = {};
var $6c0481f2cb568699$var$PATH_START = {};
var $6c0481f2cb568699$var$PATH = {};
var $6c0481f2cb568699$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $6c0481f2cb568699$var$QUERY = {};
var $6c0481f2cb568699$var$FRAGMENT = {};
// eslint-disable-next-line max-statements -- TODO
var $6c0481f2cb568699$var$parseURL = function parseURL(url, input, stateOverride, base) {
    var state = stateOverride || $6c0481f2cb568699$var$SCHEME_START;
    var pointer = 0;
    var buffer = "";
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    if (!stateOverride) {
        url.scheme = "";
        url.username = "";
        url.password = "";
        url.host = null;
        url.port = null;
        url.path = [];
        url.query = null;
        url.fragment = null;
        url.cannotBeABaseURL = false;
        input = $6c0481f2cb568699$var$replace(input, $6c0481f2cb568699$var$LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, "");
    }
    input = $6c0481f2cb568699$var$replace(input, $6c0481f2cb568699$var$TAB_AND_NEW_LINE, "");
    codePoints = $0a4fb4e96a13ece2$exports(input);
    while(pointer <= codePoints.length){
        chr = codePoints[pointer];
        switch(state){
            case $6c0481f2cb568699$var$SCHEME_START:
                if (chr && $6c0481f2cb568699$var$exec($6c0481f2cb568699$var$ALPHA, chr)) {
                    buffer += $6c0481f2cb568699$var$toLowerCase(chr);
                    state = $6c0481f2cb568699$var$SCHEME;
                } else if (!stateOverride) {
                    state = $6c0481f2cb568699$var$NO_SCHEME;
                    continue;
                } else return $6c0481f2cb568699$var$INVALID_SCHEME;
                break;
            case $6c0481f2cb568699$var$SCHEME:
                if (chr && ($6c0481f2cb568699$var$exec($6c0481f2cb568699$var$ALPHANUMERIC, chr) || chr == "+" || chr == "-" || chr == ".")) buffer += $6c0481f2cb568699$var$toLowerCase(chr);
                else if (chr == ":") {
                    if (stateOverride && ($6c0481f2cb568699$var$isSpecial(url) != $f886a2c1b39b3cb3$exports($6c0481f2cb568699$var$specialSchemes, buffer) || buffer == "file" && ($6c0481f2cb568699$var$includesCredentials(url) || url.port !== null) || url.scheme == "file" && !url.host)) return;
                    url.scheme = buffer;
                    if (stateOverride) {
                        if ($6c0481f2cb568699$var$isSpecial(url) && $6c0481f2cb568699$var$specialSchemes[url.scheme] == url.port) url.port = null;
                        return;
                    }
                    buffer = "";
                    if (url.scheme == "file") state = $6c0481f2cb568699$var$FILE;
                    else if ($6c0481f2cb568699$var$isSpecial(url) && base && base.scheme == url.scheme) state = $6c0481f2cb568699$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                    else if ($6c0481f2cb568699$var$isSpecial(url)) state = $6c0481f2cb568699$var$SPECIAL_AUTHORITY_SLASHES;
                    else if (codePoints[pointer + 1] == "/") {
                        state = $6c0481f2cb568699$var$PATH_OR_AUTHORITY;
                        pointer++;
                    } else {
                        url.cannotBeABaseURL = true;
                        $6c0481f2cb568699$var$push(url.path, "");
                        state = $6c0481f2cb568699$var$CANNOT_BE_A_BASE_URL_PATH;
                    }
                } else if (!stateOverride) {
                    buffer = "";
                    state = $6c0481f2cb568699$var$NO_SCHEME;
                    pointer = 0;
                    continue;
                } else return $6c0481f2cb568699$var$INVALID_SCHEME;
                break;
            case $6c0481f2cb568699$var$NO_SCHEME:
                if (!base || base.cannotBeABaseURL && chr != "#") return $6c0481f2cb568699$var$INVALID_SCHEME;
                if (base.cannotBeABaseURL && chr == "#") {
                    url.scheme = base.scheme;
                    url.path = $b0517415a927cb81$exports(base.path);
                    url.query = base.query;
                    url.fragment = "";
                    url.cannotBeABaseURL = true;
                    state = $6c0481f2cb568699$var$FRAGMENT;
                    break;
                }
                state = base.scheme == "file" ? $6c0481f2cb568699$var$FILE : $6c0481f2cb568699$var$RELATIVE;
                continue;
            case $6c0481f2cb568699$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                if (chr == "/" && codePoints[pointer + 1] == "/") {
                    state = $6c0481f2cb568699$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    pointer++;
                } else {
                    state = $6c0481f2cb568699$var$RELATIVE;
                    continue;
                }
                break;
            case $6c0481f2cb568699$var$PATH_OR_AUTHORITY:
                if (chr == "/") {
                    state = $6c0481f2cb568699$var$AUTHORITY;
                    break;
                } else {
                    state = $6c0481f2cb568699$var$PATH;
                    continue;
                }
            case $6c0481f2cb568699$var$RELATIVE:
                url.scheme = base.scheme;
                if (chr == $6c0481f2cb568699$var$EOF) {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = $b0517415a927cb81$exports(base.path);
                    url.query = base.query;
                } else if (chr == "/" || chr == "\\" && $6c0481f2cb568699$var$isSpecial(url)) state = $6c0481f2cb568699$var$RELATIVE_SLASH;
                else if (chr == "?") {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = $b0517415a927cb81$exports(base.path);
                    url.query = "";
                    state = $6c0481f2cb568699$var$QUERY;
                } else if (chr == "#") {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = $b0517415a927cb81$exports(base.path);
                    url.query = base.query;
                    url.fragment = "";
                    state = $6c0481f2cb568699$var$FRAGMENT;
                } else {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    url.path = $b0517415a927cb81$exports(base.path);
                    url.path.length--;
                    state = $6c0481f2cb568699$var$PATH;
                    continue;
                }
                break;
            case $6c0481f2cb568699$var$RELATIVE_SLASH:
                if ($6c0481f2cb568699$var$isSpecial(url) && (chr == "/" || chr == "\\")) state = $6c0481f2cb568699$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                else if (chr == "/") state = $6c0481f2cb568699$var$AUTHORITY;
                else {
                    url.username = base.username;
                    url.password = base.password;
                    url.host = base.host;
                    url.port = base.port;
                    state = $6c0481f2cb568699$var$PATH;
                    continue;
                }
                break;
            case $6c0481f2cb568699$var$SPECIAL_AUTHORITY_SLASHES:
                state = $6c0481f2cb568699$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                if (chr != "/" || $6c0481f2cb568699$var$charAt(buffer, pointer + 1) != "/") continue;
                pointer++;
                break;
            case $6c0481f2cb568699$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                if (chr != "/" && chr != "\\") {
                    state = $6c0481f2cb568699$var$AUTHORITY;
                    continue;
                }
                break;
            case $6c0481f2cb568699$var$AUTHORITY:
                if (chr == "@") {
                    if (seenAt) buffer = "%40" + buffer;
                    seenAt = true;
                    bufferCodePoints = $0a4fb4e96a13ece2$exports(buffer);
                    for(var i = 0; i < bufferCodePoints.length; i++){
                        var codePoint = bufferCodePoints[i];
                        if (codePoint == ":" && !seenPasswordToken) {
                            seenPasswordToken = true;
                            continue;
                        }
                        var encodedCodePoints = $6c0481f2cb568699$var$percentEncode(codePoint, $6c0481f2cb568699$var$userinfoPercentEncodeSet);
                        if (seenPasswordToken) url.password += encodedCodePoints;
                        else url.username += encodedCodePoints;
                    }
                    buffer = "";
                } else if (chr == $6c0481f2cb568699$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && $6c0481f2cb568699$var$isSpecial(url)) {
                    if (seenAt && buffer == "") return $6c0481f2cb568699$var$INVALID_AUTHORITY;
                    pointer -= $0a4fb4e96a13ece2$exports(buffer).length + 1;
                    buffer = "";
                    state = $6c0481f2cb568699$var$HOST;
                } else buffer += chr;
                break;
            case $6c0481f2cb568699$var$HOST:
            case $6c0481f2cb568699$var$HOSTNAME:
                if (stateOverride && url.scheme == "file") {
                    state = $6c0481f2cb568699$var$FILE_HOST;
                    continue;
                } else if (chr == ":" && !seenBracket) {
                    if (buffer == "") return $6c0481f2cb568699$var$INVALID_HOST;
                    failure = $6c0481f2cb568699$var$parseHost(url, buffer);
                    if (failure) return failure;
                    buffer = "";
                    state = $6c0481f2cb568699$var$PORT;
                    if (stateOverride == $6c0481f2cb568699$var$HOSTNAME) return;
                } else if (chr == $6c0481f2cb568699$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && $6c0481f2cb568699$var$isSpecial(url)) {
                    if ($6c0481f2cb568699$var$isSpecial(url) && buffer == "") return $6c0481f2cb568699$var$INVALID_HOST;
                    if (stateOverride && buffer == "" && ($6c0481f2cb568699$var$includesCredentials(url) || url.port !== null)) return;
                    failure = $6c0481f2cb568699$var$parseHost(url, buffer);
                    if (failure) return failure;
                    buffer = "";
                    state = $6c0481f2cb568699$var$PATH_START;
                    if (stateOverride) return;
                    continue;
                } else {
                    if (chr == "[") seenBracket = true;
                    else if (chr == "]") seenBracket = false;
                    buffer += chr;
                }
                break;
            case $6c0481f2cb568699$var$PORT:
                if ($6c0481f2cb568699$var$exec($6c0481f2cb568699$var$DIGIT, chr)) buffer += chr;
                else if (chr == $6c0481f2cb568699$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && $6c0481f2cb568699$var$isSpecial(url) || stateOverride) {
                    if (buffer != "") {
                        var port = $6c0481f2cb568699$var$parseInt(buffer, 10);
                        if (port > 0xFFFF) return $6c0481f2cb568699$var$INVALID_PORT;
                        url.port = $6c0481f2cb568699$var$isSpecial(url) && port === $6c0481f2cb568699$var$specialSchemes[url.scheme] ? null : port;
                        buffer = "";
                    }
                    if (stateOverride) return;
                    state = $6c0481f2cb568699$var$PATH_START;
                    continue;
                } else return $6c0481f2cb568699$var$INVALID_PORT;
                break;
            case $6c0481f2cb568699$var$FILE:
                url.scheme = "file";
                if (chr == "/" || chr == "\\") state = $6c0481f2cb568699$var$FILE_SLASH;
                else if (base && base.scheme == "file") {
                    if (chr == $6c0481f2cb568699$var$EOF) {
                        url.host = base.host;
                        url.path = $b0517415a927cb81$exports(base.path);
                        url.query = base.query;
                    } else if (chr == "?") {
                        url.host = base.host;
                        url.path = $b0517415a927cb81$exports(base.path);
                        url.query = "";
                        state = $6c0481f2cb568699$var$QUERY;
                    } else if (chr == "#") {
                        url.host = base.host;
                        url.path = $b0517415a927cb81$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = $6c0481f2cb568699$var$FRAGMENT;
                    } else {
                        if (!$6c0481f2cb568699$var$startsWithWindowsDriveLetter($6c0481f2cb568699$var$join($b0517415a927cb81$exports(codePoints, pointer), ""))) {
                            url.host = base.host;
                            url.path = $b0517415a927cb81$exports(base.path);
                            $6c0481f2cb568699$var$shortenURLsPath(url);
                        }
                        state = $6c0481f2cb568699$var$PATH;
                        continue;
                    }
                } else {
                    state = $6c0481f2cb568699$var$PATH;
                    continue;
                }
                break;
            case $6c0481f2cb568699$var$FILE_SLASH:
                if (chr == "/" || chr == "\\") {
                    state = $6c0481f2cb568699$var$FILE_HOST;
                    break;
                }
                if (base && base.scheme == "file" && !$6c0481f2cb568699$var$startsWithWindowsDriveLetter($6c0481f2cb568699$var$join($b0517415a927cb81$exports(codePoints, pointer), ""))) {
                    if ($6c0481f2cb568699$var$isWindowsDriveLetter(base.path[0], true)) $6c0481f2cb568699$var$push(url.path, base.path[0]);
                    else url.host = base.host;
                }
                state = $6c0481f2cb568699$var$PATH;
                continue;
            case $6c0481f2cb568699$var$FILE_HOST:
                if (chr == $6c0481f2cb568699$var$EOF || chr == "/" || chr == "\\" || chr == "?" || chr == "#") {
                    if (!stateOverride && $6c0481f2cb568699$var$isWindowsDriveLetter(buffer)) state = $6c0481f2cb568699$var$PATH;
                    else if (buffer == "") {
                        url.host = "";
                        if (stateOverride) return;
                        state = $6c0481f2cb568699$var$PATH_START;
                    } else {
                        failure = $6c0481f2cb568699$var$parseHost(url, buffer);
                        if (failure) return failure;
                        if (url.host == "localhost") url.host = "";
                        if (stateOverride) return;
                        buffer = "";
                        state = $6c0481f2cb568699$var$PATH_START;
                    }
                    continue;
                } else buffer += chr;
                break;
            case $6c0481f2cb568699$var$PATH_START:
                if ($6c0481f2cb568699$var$isSpecial(url)) {
                    state = $6c0481f2cb568699$var$PATH;
                    if (chr != "/" && chr != "\\") continue;
                } else if (!stateOverride && chr == "?") {
                    url.query = "";
                    state = $6c0481f2cb568699$var$QUERY;
                } else if (!stateOverride && chr == "#") {
                    url.fragment = "";
                    state = $6c0481f2cb568699$var$FRAGMENT;
                } else if (chr != $6c0481f2cb568699$var$EOF) {
                    state = $6c0481f2cb568699$var$PATH;
                    if (chr != "/") continue;
                }
                break;
            case $6c0481f2cb568699$var$PATH:
                if (chr == $6c0481f2cb568699$var$EOF || chr == "/" || chr == "\\" && $6c0481f2cb568699$var$isSpecial(url) || !stateOverride && (chr == "?" || chr == "#")) {
                    if ($6c0481f2cb568699$var$isDoubleDot(buffer)) {
                        $6c0481f2cb568699$var$shortenURLsPath(url);
                        if (chr != "/" && !(chr == "\\" && $6c0481f2cb568699$var$isSpecial(url))) $6c0481f2cb568699$var$push(url.path, "");
                    } else if ($6c0481f2cb568699$var$isSingleDot(buffer)) {
                        if (chr != "/" && !(chr == "\\" && $6c0481f2cb568699$var$isSpecial(url))) $6c0481f2cb568699$var$push(url.path, "");
                    } else {
                        if (url.scheme == "file" && !url.path.length && $6c0481f2cb568699$var$isWindowsDriveLetter(buffer)) {
                            if (url.host) url.host = "";
                            buffer = $6c0481f2cb568699$var$charAt(buffer, 0) + ":"; // normalize windows drive letter
                        }
                        $6c0481f2cb568699$var$push(url.path, buffer);
                    }
                    buffer = "";
                    if (url.scheme == "file" && (chr == $6c0481f2cb568699$var$EOF || chr == "?" || chr == "#")) while(url.path.length > 1 && url.path[0] === "")$6c0481f2cb568699$var$shift(url.path);
                    if (chr == "?") {
                        url.query = "";
                        state = $6c0481f2cb568699$var$QUERY;
                    } else if (chr == "#") {
                        url.fragment = "";
                        state = $6c0481f2cb568699$var$FRAGMENT;
                    }
                } else buffer += $6c0481f2cb568699$var$percentEncode(chr, $6c0481f2cb568699$var$pathPercentEncodeSet);
                break;
            case $6c0481f2cb568699$var$CANNOT_BE_A_BASE_URL_PATH:
                if (chr == "?") {
                    url.query = "";
                    state = $6c0481f2cb568699$var$QUERY;
                } else if (chr == "#") {
                    url.fragment = "";
                    state = $6c0481f2cb568699$var$FRAGMENT;
                } else if (chr != $6c0481f2cb568699$var$EOF) url.path[0] += $6c0481f2cb568699$var$percentEncode(chr, $6c0481f2cb568699$var$C0ControlPercentEncodeSet);
                break;
            case $6c0481f2cb568699$var$QUERY:
                if (!stateOverride && chr == "#") {
                    url.fragment = "";
                    state = $6c0481f2cb568699$var$FRAGMENT;
                } else if (chr != $6c0481f2cb568699$var$EOF) {
                    if (chr == "'" && $6c0481f2cb568699$var$isSpecial(url)) url.query += "%27";
                    else if (chr == "#") url.query += "%23";
                    else url.query += $6c0481f2cb568699$var$percentEncode(chr, $6c0481f2cb568699$var$C0ControlPercentEncodeSet);
                }
                break;
            case $6c0481f2cb568699$var$FRAGMENT:
                if (chr != $6c0481f2cb568699$var$EOF) url.fragment += $6c0481f2cb568699$var$percentEncode(chr, $6c0481f2cb568699$var$fragmentPercentEncodeSet);
                break;
        }
        pointer++;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $6c0481f2cb568699$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $e39fe418a5804d3d$exports(this, $6c0481f2cb568699$var$URLPrototype);
    var base = arguments.length > 1 ? arguments[1] : undefined;
    var urlString = $51d8b5b522168b52$exports(url);
    var state = $6c0481f2cb568699$var$setInternalState(that, {
        type: "URL"
    });
    var baseState, failure;
    if (base !== undefined) try {
        baseState = $6c0481f2cb568699$var$getInternalURLState(base);
    } catch (error) {
        failure = $6c0481f2cb568699$var$parseURL(baseState = {}, $51d8b5b522168b52$exports(base));
        if (failure) throw $6c0481f2cb568699$var$TypeError(failure);
    }
    failure = $6c0481f2cb568699$var$parseURL(state, urlString, null, baseState);
    if (failure) throw $6c0481f2cb568699$var$TypeError(failure);
    var searchParams = state.searchParams = new $6c0481f2cb568699$var$URLSearchParams();
    var searchParamsState = $6c0481f2cb568699$var$getInternalSearchParamsState(searchParams);
    searchParamsState.updateSearchParams(state.query);
    searchParamsState.updateURL = function() {
        state.query = $51d8b5b522168b52$exports(searchParams) || null;
    };
    if (!$20523523a5693ba2$exports) {
        that.href = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$serializeURL, that);
        that.origin = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getOrigin, that);
        that.protocol = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getProtocol, that);
        that.username = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getUsername, that);
        that.password = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getPassword, that);
        that.host = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getHost, that);
        that.hostname = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getHostname, that);
        that.port = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getPort, that);
        that.pathname = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getPathname, that);
        that.search = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getSearch, that);
        that.searchParams = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getSearchParams, that);
        that.hash = $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$getHash, that);
    }
};
var $6c0481f2cb568699$var$URLPrototype = $6c0481f2cb568699$var$URLConstructor.prototype;
var $6c0481f2cb568699$var$serializeURL = function serializeURL() {
    var url = $6c0481f2cb568699$var$getInternalURLState(this);
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ":";
    if (host !== null) {
        output += "//";
        if ($6c0481f2cb568699$var$includesCredentials(url)) output += username + (password ? ":" + password : "") + "@";
        output += $6c0481f2cb568699$var$serializeHost(host);
        if (port !== null) output += ":" + port;
    } else if (scheme == "file") output += "//";
    output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + $6c0481f2cb568699$var$join(path, "/") : "";
    if (query !== null) output += "?" + query;
    if (fragment !== null) output += "#" + fragment;
    return output;
};
var $6c0481f2cb568699$var$getOrigin = function getOrigin() {
    var url = $6c0481f2cb568699$var$getInternalURLState(this);
    var scheme = url.scheme;
    var port = url.port;
    if (scheme == "blob") try {
        return new $6c0481f2cb568699$var$URLConstructor(scheme.path[0]).origin;
    } catch (error) {
        return "null";
    }
    if (scheme == "file" || !$6c0481f2cb568699$var$isSpecial(url)) return "null";
    return scheme + "://" + $6c0481f2cb568699$var$serializeHost(url.host) + (port !== null ? ":" + port : "");
};
var $6c0481f2cb568699$var$getProtocol = function getProtocol() {
    return $6c0481f2cb568699$var$getInternalURLState(this).scheme + ":";
};
var $6c0481f2cb568699$var$getUsername = function getUsername() {
    return $6c0481f2cb568699$var$getInternalURLState(this).username;
};
var $6c0481f2cb568699$var$getPassword = function getPassword() {
    return $6c0481f2cb568699$var$getInternalURLState(this).password;
};
var $6c0481f2cb568699$var$getHost = function getHost() {
    var url = $6c0481f2cb568699$var$getInternalURLState(this);
    var host = url.host;
    var port = url.port;
    return host === null ? "" : port === null ? $6c0481f2cb568699$var$serializeHost(host) : $6c0481f2cb568699$var$serializeHost(host) + ":" + port;
};
var $6c0481f2cb568699$var$getHostname = function getHostname() {
    var host = $6c0481f2cb568699$var$getInternalURLState(this).host;
    return host === null ? "" : $6c0481f2cb568699$var$serializeHost(host);
};
var $6c0481f2cb568699$var$getPort = function getPort() {
    var port = $6c0481f2cb568699$var$getInternalURLState(this).port;
    return port === null ? "" : $51d8b5b522168b52$exports(port);
};
var $6c0481f2cb568699$var$getPathname = function getPathname() {
    var url = $6c0481f2cb568699$var$getInternalURLState(this);
    var path = url.path;
    return url.cannotBeABaseURL ? path[0] : path.length ? "/" + $6c0481f2cb568699$var$join(path, "/") : "";
};
var $6c0481f2cb568699$var$getSearch = function getSearch() {
    var query = $6c0481f2cb568699$var$getInternalURLState(this).query;
    return query ? "?" + query : "";
};
var $6c0481f2cb568699$var$getSearchParams = function getSearchParams() {
    return $6c0481f2cb568699$var$getInternalURLState(this).searchParams;
};
var $6c0481f2cb568699$var$getHash = function getHash() {
    var fragment = $6c0481f2cb568699$var$getInternalURLState(this).fragment;
    return fragment ? "#" + fragment : "";
};
var $6c0481f2cb568699$var$accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
        get: getter,
        set: setter,
        configurable: true,
        enumerable: true
    };
};
if ($20523523a5693ba2$exports) $3157e86efe959573$exports($6c0481f2cb568699$var$URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$serializeURL, function(href) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        var urlString = $51d8b5b522168b52$exports(href);
        var failure = $6c0481f2cb568699$var$parseURL(url, urlString);
        if (failure) throw $6c0481f2cb568699$var$TypeError(failure);
        $6c0481f2cb568699$var$getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getProtocol, function(protocol) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        $6c0481f2cb568699$var$parseURL(url, $51d8b5b522168b52$exports(protocol) + ":", $6c0481f2cb568699$var$SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getUsername, function(username) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        var codePoints = $0a4fb4e96a13ece2$exports($51d8b5b522168b52$exports(username));
        if ($6c0481f2cb568699$var$cannotHaveUsernamePasswordPort(url)) return;
        url.username = "";
        for(var i = 0; i < codePoints.length; i++)url.username += $6c0481f2cb568699$var$percentEncode(codePoints[i], $6c0481f2cb568699$var$userinfoPercentEncodeSet);
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getPassword, function(password) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        var codePoints = $0a4fb4e96a13ece2$exports($51d8b5b522168b52$exports(password));
        if ($6c0481f2cb568699$var$cannotHaveUsernamePasswordPort(url)) return;
        url.password = "";
        for(var i = 0; i < codePoints.length; i++)url.password += $6c0481f2cb568699$var$percentEncode(codePoints[i], $6c0481f2cb568699$var$userinfoPercentEncodeSet);
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getHost, function(host) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        if (url.cannotBeABaseURL) return;
        $6c0481f2cb568699$var$parseURL(url, $51d8b5b522168b52$exports(host), $6c0481f2cb568699$var$HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getHostname, function(hostname) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        if (url.cannotBeABaseURL) return;
        $6c0481f2cb568699$var$parseURL(url, $51d8b5b522168b52$exports(hostname), $6c0481f2cb568699$var$HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getPort, function(port) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        if ($6c0481f2cb568699$var$cannotHaveUsernamePasswordPort(url)) return;
        port = $51d8b5b522168b52$exports(port);
        if (port == "") url.port = null;
        else $6c0481f2cb568699$var$parseURL(url, port, $6c0481f2cb568699$var$PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getPathname, function(pathname) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        if (url.cannotBeABaseURL) return;
        url.path = [];
        $6c0481f2cb568699$var$parseURL(url, $51d8b5b522168b52$exports(pathname), $6c0481f2cb568699$var$PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getSearch, function(search) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        search = $51d8b5b522168b52$exports(search);
        if (search == "") url.query = null;
        else {
            if ("?" == $6c0481f2cb568699$var$charAt(search, 0)) search = $6c0481f2cb568699$var$stringSlice(search, 1);
            url.query = "";
            $6c0481f2cb568699$var$parseURL(url, search, $6c0481f2cb568699$var$QUERY);
        }
        $6c0481f2cb568699$var$getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: $6c0481f2cb568699$var$accessorDescriptor($6c0481f2cb568699$var$getHash, function(hash) {
        var url = $6c0481f2cb568699$var$getInternalURLState(this);
        hash = $51d8b5b522168b52$exports(hash);
        if (hash == "") {
            url.fragment = null;
            return;
        }
        if ("#" == $6c0481f2cb568699$var$charAt(hash, 0)) hash = $6c0481f2cb568699$var$stringSlice(hash, 1);
        url.fragment = "";
        $6c0481f2cb568699$var$parseURL(url, hash, $6c0481f2cb568699$var$FRAGMENT);
    })
});
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$f148dd7e55499544$exports($6c0481f2cb568699$var$URLPrototype, "toJSON", function toJSON() {
    return $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$serializeURL, this);
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$f148dd7e55499544$exports($6c0481f2cb568699$var$URLPrototype, "toString", function toString() {
    return $aac63ddfd5f198a9$exports($6c0481f2cb568699$var$serializeURL, this);
}, {
    enumerable: true
});
if ($6c0481f2cb568699$var$NativeURL) {
    var $6c0481f2cb568699$var$nativeCreateObjectURL = $6c0481f2cb568699$var$NativeURL.createObjectURL;
    var $6c0481f2cb568699$var$nativeRevokeObjectURL = $6c0481f2cb568699$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($6c0481f2cb568699$var$nativeCreateObjectURL) $f148dd7e55499544$exports($6c0481f2cb568699$var$URLConstructor, "createObjectURL", $bb7f2fab244cc9f4$exports($6c0481f2cb568699$var$nativeCreateObjectURL, $6c0481f2cb568699$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($6c0481f2cb568699$var$nativeRevokeObjectURL) $f148dd7e55499544$exports($6c0481f2cb568699$var$URLConstructor, "revokeObjectURL", $bb7f2fab244cc9f4$exports($6c0481f2cb568699$var$nativeRevokeObjectURL, $6c0481f2cb568699$var$NativeURL));
}
$04a3155e98ce866f$exports($6c0481f2cb568699$var$URLConstructor, "URL");
$ca7e2546bb28a324$exports({
    global: true,
    forced: !$eae9cfd3a574c033$exports,
    sham: !$20523523a5693ba2$exports
}, {
    URL: $6c0481f2cb568699$var$URLConstructor
});


"use strict";


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$ca7e2546bb28a324$exports({
    target: "URL",
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $aac63ddfd5f198a9$exports(URL.prototype.toString, this);
    }
});




$55b59fa101c837af$exports = $2a825a53c6152885$exports.URL;


$e0723339388ba3db$exports = $55b59fa101c837af$exports;


$8b2b7f58bf0f3834$exports = $e0723339388ba3db$exports;


var $e39b96323b5937af$exports = {};
var $e39b96323b5937af$var$_this = $e39b96323b5937af$exports;
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (function() {
    (function(root, factory) {
        if (0, $e39b96323b5937af$exports) // CommonJS
        return $e39b96323b5937af$exports = factory();
        else if (typeof define === "function" && define.amd) // AMD
        define([], function() {
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })($e39b96323b5937af$var$_this, function() {
        var TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: function(elementId) {
                var element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", function() {
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", function() {
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", function() {
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", function() {
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", function() {
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: function(elementId) {
                var time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: function(pageName, startTime) {
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    var arrayOfTimes = TimeMe.startStopTimes[pageName];
                    var latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: function() {
                var pageNames = Object.keys(TimeMe.startStopTimes);
                for(var i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: function(pageName, stopTime) {
                if (!pageName) pageName = TimeMe.currentPageName;
                var arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: function() {
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: function(pageName) {
                var timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: function() {
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: function(pageName) {
                var totalTimeOnPage = 0;
                var arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                var timeSpentOnPageInSeconds = 0;
                for(var i = 0; i < arrayOfTimes.length; i++){
                    var startTime = arrayOfTimes[i].startTime;
                    var stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    var difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: function() {
                var allTimes = [];
                var pageNames = Object.keys(TimeMe.startStopTimes);
                for(var i = 0; i < pageNames.length; i++){
                    var pageName = pageNames[i];
                    var timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: function(duration) {
                var durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: function(pageName) {
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: function(pageName) {
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: function() {
                var pageNames = Object.keys(TimeMe.startStopTimes);
                for(var i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: function() {
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: function() {
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: function(callback, numberOfTimesToInvoke) {
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: function(callback, numberOfTimesToInvoke) {
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: function() {
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(var i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        var userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        var numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: function() {
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(var i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        var userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        var numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: function(timeInSeconds, callback) {
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: function() {
                for(var i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: function(trackWhenUserLeavesPage, trackWhenUserGoesIdle) {
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: function() {
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, function() {
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener("blur", function() {
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener("focus", function() {
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: function() {
                document.addEventListener("mousemove", function() {
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", function() {
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", function() {
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", function() {
                    TimeMe.userActivityDetected();
                });
                setInterval(function() {
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: function(websocketOptions) {
                if (window.WebSocket && websocketOptions) {
                    var websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = function() {
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = function() {
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = function(error) {
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = function(event) {
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: function(data) {
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: function(appId) {
                var timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                var data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: function(appId) {
                var data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: function(options) {
                var idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                var currentPageName = TimeMe.currentPageName || "default-page-name";
                var websocketOptions = undefined;
                var initialStartTime = undefined;
                var trackWhenUserLeavesPage = true;
                var trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call($e39b96323b5937af$exports);


/** Trap click-throughs and trigger OCRM activities. */ $(function() {
    /**
   * Trap <a href=".."> clicks in the main body and
   * pass-and-forget them to raise Activities in OpenCRM.
   *
   * Links to other 55redefined.com pages are ignored.
   */ $(".js-tracked a").on("click tap", function(e) {
        try {
            var a = $(e.target);
            var href = a.attr("href");
            if (!href) href = $(e.target).parents("a").attr("href");
            if (!href) return;
            var domains = [
                "jobs-redefined.co",
                "life-redefined.co",
                "work-redefined.co",
                "55redefined.co",
                "55redefined.com"
            ];
            var ownSite = !href.startsWith("http") || domains.some(function(domain) {
                return href && new (0, (/*@__PURE__*/$parcel$interopDefault($8b2b7f58bf0f3834$exports)))(href).hostname === domain;
            });
            if (!ownSite) {
                var pageId = $(".js-tracking").data("trackingItemId") || "";
                var q = new (0, (/*@__PURE__*/$parcel$interopDefault($cc41b945fd7849be$exports)))({
                    target: href,
                    pageId: pageId,
                    t: new Date()
                });
                fetch("/_trackEmbeddedLink?" + q.toString()).then(function() {
                    return null;
                }).catch(function(err) {
                    console.warn("Attempting to link to ".concat(href), err);
                });
            }
        } catch (err) {
            console.error("Attempting to link to ".concat(href), err);
        }
    });
});
/**
 * Trap callback integration clicks to record initiating
 * a callback, which the user may or may not complete.
 */ $("a.js-initiate-callback").on("click tap", function(e) {
    var partner = $(e.target).data("partner");
    fetch("/_trackCallbackStarted?partner=" + partner).then(function() {
        return null;
    }).catch(function(err) {
        console.warn(err);
    });
});
/** Set up a dwell time tracker. */ $(function() {
    var settings = $("div.js-tracking");
    if (!settings || settings.length === 0) return;
    var _$_data;
    var config = (_$_data = $(settings[0]).data()) !== null && _$_data !== void 0 ? _$_data : {};
    var rawTimeout = parseInt(config["trackingTimeout"]);
    var timeout = isFinite(rawTimeout) && rawTimeout > 0 ? rawTimeout : 30;
    (0, (/*@__PURE__*/$parcel$interopDefault($e39b96323b5937af$exports))).initialize({
        // must be much greater than the call timeout otherwise
        // it's assumed the reader has gone for good
        idleTimeoutInSeconds: 86400,
        // staring at the page without scrolling will count
        trackWhenUserGoesIdle: true,
        // triggers when cumulative time on this page reaches the timeout
        trackWhenUserLeavesPage: true
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($e39b96323b5937af$exports))).callAfterTimeElapsedInSeconds(timeout, function() {
        var tracker = $("div.js-tracking");
        if (tracker.length > 0) {
            var data = $(tracker[0]).data() || {};
            var itemId = data["trackingItemId"] || "";
            var categoryId = data["trackingCategoryId"] || data["trackingToplevelCategoryId"] || "";
            var title = data["trackingTitle"];
            var q = new (0, (/*@__PURE__*/$parcel$interopDefault($cc41b945fd7849be$exports)))({
                itemId: itemId,
                categoryId: categoryId,
                title: title
            });
            fetch("/_trackContentRead?" + q.toString()).then(function() {}).catch(function(err) {
                console.warn(err);
            });
        }
    });
});


$(function() {
    $("a.js-verification-trigger").on("click tap", function(e) {
        e.preventDefault();
        var id = $(e.target).data("id") || "";
        var email = $(e.target).data("email") || "";
        var url = "/users/resend-verification?userId=" + id + "&email=" + email;
        fetch(url).then(function(_resp) {
            // replace the text
            $(".js-verification-placeholder").html("Requested");
            return false;
        }).catch(function(_err) {
            // leave the link in place
            return false;
        });
    });
});


// Login redirect means building URLs with ?returnTo=/foo/bar#baz,
// which means careful encoding. The built-in URL / URLSearchParams
// can do this but it isn't supported at all by IE11. So we need
// *both* polyfills, and parcel can't back-fill by itself.
// Ignore VS code telling you one is unused


$(function() {
    // this is included on sites without login enabled, so check to make sure lock is included
    if (typeof Auth0Lock === "undefined" || typeof authenticationConfig === "undefined") return;
    var publicSite = authenticationConfig.publicSite || "https://life-redefined.co/";
    var languageDictionary = {};
    var additionalSignUpFields = [
        {
            // on the user, not their metadata
            name: "given_name",
            placeholder: "Your first name",
            validator: function validator(the_name) {
                return {
                    valid: the_name && the_name.trim().length > 0,
                    hint: "Name can't be blank"
                };
            },
            storage: "root"
        },
        {
            // on the user, not their metadata
            name: "family_name",
            placeholder: "Your surname",
            validator: function validator(the_name) {
                return {
                    valid: the_name && the_name.trim().length > 0,
                    hint: "Name can't be blank"
                };
            },
            storage: "root"
        },
        {
            // on the metadata to avoid conflicting
            // with Auth0's own use of phone numbers
            name: "phone",
            placeholder: "Telephone (optional)",
            validator: function validator(the_title) {
                return true;
            }
        }
    ];
    additionalSignUpFields.push({
        type: "hidden",
        name: "registration_type",
        placeholder: "Registration Type",
        value: "Member"
    });
    languageDictionary.signUpTitle = "Register";
    languageDictionary.signUpLabel = "Register";
    languageDictionary.signUpSubmitLabel = "Register";
    languageDictionary.signUpWithLabel = "Register with %s";
    languageDictionary.signUpTerms = "By registering, you agree to our <a href='".concat(publicSite, "info/formal-stuff#wtac'>Terms and Conditions</a> and <a href='").concat(publicSite, "info/formal-stuff#pacp'>Privacy Policy</a>");
    languageDictionary.error = {
        signUp: {
            "lock.fallback": "Registration unsuccessful.<br/>If you've already registered with this email address, please login with your existing password"
        }
    };
    var lock = new Auth0Lock(authenticationConfig.clientID, authenticationConfig.auth0Domain, {
        initialScreen: "login",
        auth: {
            redirectUrl: authenticationConfig.callback,
            responseType: "id_token",
            redirect: false
        },
        rememberLastLogin: true,
        languageDictionary: languageDictionary,
        theme: {
            logo: "https://life-redefined.co/images/logo-life.svg",
            primaryColor: "#E8500E"
        },
        closable: true,
        autoclose: true,
        defaultADUsernameFromEmailPrefix: false,
        allowForgotPassword: true,
        additionalSignUpFields: additionalSignUpFields
    });
    // is registering as opposed to logging in
    var isRegistering = true;
    lock.on("authenticated", function(authResult) {
        // if our state data looks like a local URL, use it.
        var state = authResult.state;
        var returnTo = /^\//.test(state) ? state : "/";
        // This is /login, which goes through getLoginState in app.ts.
        // That end can't separate a new registration from a normal
        // login so we tell it on the query string, plus the url
        // to go after registration if it's set via Static Data.
        var u = new (0, (/*@__PURE__*/$parcel$interopDefault($8b2b7f58bf0f3834$exports)))(authenticationConfig.redirectUrl);
        u.searchParams.append("returnTo", returnTo);
        u.searchParams.append("isRegistering", isRegistering);
        u.searchParams.append("postRegistration", authenticationConfig.postRegistrationPage);
        window.location.href = u.toString();
    });
    lock.on("hide", function() {
        $("body").removeClass("prevent-scroll");
    });
    // ensure the sidebar copy is correct, triggered on all appearances.
    lock.on("show", function() {
        $(".auth0-lock-container").addClass("with-benefits");
        updateSidebarCopy();
    });
    // toggle sidebar content, triggered when the login/register side changes
    // and on the first appearance of this Lock popup, does *not* trigger on
    // 2nd and subsequent appearances if the side has not changed!
    lock.on("signin ready", function() {
        isRegistering = false;
        updateSidebarCopy();
    });
    lock.on("signup ready", function() {
        isRegistering = true;
        updateSidebarCopy();
    });
    $(".js-login").on("click", function(event) {
        event.preventDefault();
        $("body").addClass("prevent-scroll");
        var opts = buildReturnToOpts(event);
        lock.show(opts);
    });
    $('[href$="/users/register"]').on("click", function(event) {
        event.preventDefault();
        $("body").addClass("prevent-scroll");
        var opts = buildReturnToOpts(event, "signUp");
        lock.show(opts);
    });
    $(".js-register").on("click", function(event) {
        event.preventDefault();
        $("body").addClass("prevent-scroll");
        var opts = buildReturnToOpts(event, "signUp");
        lock.show(opts);
    });
    // switch sidebar copy between login and signup
    var updateSidebarCopy = function updateSidebarCopy() {
        var copy = "";
        if (isRegistering) copy = $("#member-benefits-copy").html();
        else copy = $("#login-popup-copy").html();
        $(".benefits-copy").remove();
        if (copy && copy.length > 0) {
            var sidebar = $('<div class="benefits-copy">');
            sidebar.html(copy);
            var sidebarParent = $(".auth0-lock-content");
            sidebarParent.prepend(sidebar);
        }
    };
    var buildReturnToOpts = function buildReturnToOpts(event, initialScreen) {
        // propagate the "return to" URL through the state parameter,
        // this is picked up later in lock.on("authenticated", ...)
        // the event target could be an A element or something within it.
        var direct = $(event.target).data("return-to");
        var register = $(event.target).parents(".js-register").data("return-to");
        var login = $(event.target).parents(".js-login").data("return-to");
        var returnTo = direct || register || login || "/";
        return {
            auth: {
                params: {
                    state: returnTo
                }
            },
            initialScreen: initialScreen || "login"
        };
    };
});


$(function() {
    var triggerIntegration = function triggerIntegration() {
        var hash = window.location.hash || "";
        if (hash.startsWith("#partner-integration-") || hash.startsWith("#legacy-partner-integration-")) {
            var component = $(hash);
            var cta = component.find(".integration-button");
            if (cta.length > 0) {
                window.location.hash = "";
                cta.get(0).click();
            }
        }
    };
    if (window.location.hash) triggerIntegration();
    $(window).on("hashchange", function() {
        triggerIntegration();
    });
});


/** GA stuff. */ $(function() {
    if (window.dataLayer) {
        var tags = $("head").find("meta[name^='custom:']");
        if (tags.length > 0) {
            var message = {
                event: "record_page_metadata"
            };
            tags.each(function(_index, domElement) {
                var cashElement = $(domElement);
                var content = cashElement.attr("content");
                if (content) message[cashElement.attr("name").replace("custom:", "")] = content;
            });
            if (Object.keys(message).length > 1) window.dataLayer.push(message);
        }
    }
});



})();
//# sourceMappingURL=bundle.js.map
